
/* Резервацията · три екрана върху една страница.
   Сглобява се от mila/rezervaciya-js.js, не се пипа направо в темата. */
(function(){
'use strict';

var БАЗА    = "https://dbmpfrvhyqinojpgsovi.supabase.co";
var КЛЮЧ    = "sb_publishable_iKNs-0TUtGwv39D1cF334A_5OK9G62W";
var ВАРИАНТИ= {"0": 54378593616200, "5": 54133694955848, "10": 54133694988616, "13": 54104073470280, "15": 54133695021384, "20": 54133695054152, "25": 54236849078600, "30": 54133695086920, "35": 54104073503048, "40": 54236849242440, "45": 54104073568584, "50": 54133695119688, "52": 54104073601352, "55": 54133695152456, "60": 54236849275208, "65": 54133695185224, "66": 54104073634120, "70": 54236849307976, "71": 54104073666888, "75": 54236849373512, "77": 54104073699656, "80": 54236849439048, "85": 54236849701192, "90": 54133695217992, "95": 54236849733960, "100": 54104073732424, "105": 54236849766728, "110": 54236849799496, "115": 54236849832264, "120": 54236849865032, "154": 54104073765192, "200": 54104073797960, "256": 54104073830728, "320": 54104073863496, "330": 54133695250760, "380": 54133695283528, "400": 54104073896264, "450": 54104073929032, "500": 54104073961800, "550": 54104073994568, "1000": 54104074027336, "1500": 54104074060104};      // сума в евро → номер на вариант в Shopify

var сек = document.getElementById('rez');
if(!сек) return;

// На страницата на процедурата услугата е една и се знае. На „Запази час"
// човекът я избира и всичко трябва да се пренастрои. Затова не са
// константи, а стойности, които се четат наново от dataset-а.
var УСЛУГА, ПЪЛНА, КАПАРО, ТРАЕНЕ, ИМЕ, ОСТАТЪК, НИВА, ИЗБРАНО, БЕЗ_ИМЕ, ЗОНИ;
// Вдигнат, когато цената идва от избрани зони. Тогава цената на
// продукта носител НЕ важи: тя е само за да се намери свободен час.
var ПО_ЗОНИ = false, ИМЕ_ЗОНИ = null, ПАКЕТ = 0;
var ЦЕНА_ОТ_ЧИПА = null;   // цена, подадена от избора; пада щом часовете дойдат
var ЦЕНИ = {};      // име на специалист → неговата цена
var ПОКАПАРО = {};  // същото, но както идва от базата: по staff_id

// КАПАРО ПРИ ЛАЗЕРНИТЕ ЗОНИ: 100 € от 300 € нагоре.
//
// Антонио, 2.11.2026: зоните по същото правило като услугите при Грета
// (`service_staff.deposit` = 100 от 300 € нагоре). Сборът от зони се
// смята тук, в браузъра, затова и капарото му е тук, не в базата.
// Под 300 € няма капаро. Лазерът в базата е само при Грета; Антонио:
// „100 евро просто капаро над 300 и готово", без изключения по човек.
var ЗОНИ_ПРАГ = 300, ЗОНИ_КАПАРО = 100;
function капароЗаЗоните(){
  return ПЪЛНА >= ЗОНИ_ПРАГ ? ЗОНИ_КАПАРО : 0;
}
var ПОНИВА = {};    // услуга → свободните ѝ часове
// Колко трае всяка услуга, както го казва базата.
//
// Защо отделно: ТРАЕНЕ идваше САМО от продукта носител. На маникюра той
// е „Комбиниран маникюр без лак" — 40 минути. Избереш ли маникюр плюс
// педикюр, горе пишеше 180, но часът се заделяше за 40 и в календара на
// Ивон влизаше 10:00–10:40. Тя щеше да приеме втора жена в 11:00 върху
// същите три часа. Антонио, 10.10.2026: „избрал съм маникюр плюс
// педикюр, горе пише 180 минути, а ми запазва от 10 до 10:40."
var ТРАЕНЕ_НА = {};
// Зареждат ли се още часовете. Докато е true, никой няма право да каже
// „няма свободно" или „обади се": просто още не знаем.
// Антонио, 10.10.2026: „пише този избор не се запазва онлайн и излиза
// телефон, а като разцъках другите, излезе календар."
var ЗАРЕЖДА = true;
var ПОКОЛЕНИЕ = 0;   // кое сваляне е последното: само то има право да пише
window.MILA_ZAREZHDA = function(){ return ЗАРЕЖДА; };

// Знаем ли изобщо нещо за тази услуга?
//
// На „Запази час" чиповете се рисуват един миг преди резервацията да е
// превключила на поисканата процедура (`?usluga=`). Цъкне ли се чип точно
// там, `MILA_OGRANICHI` не намира нито един ред, семейството казва „този
// избор не се запазва онлайн" и страницата остава така ЗАВИНАГИ — нищо не
// я подканя да опита пак. Рекламният чат го хвана на 27.10.2026 на
// устните; прозорецът е милисекунди на бърза връзка и по-широк на телефон.
//
// Затова разликата между „няма такова нещо" и „още не съм стигнал дотам"
// се казва на глас. Второто е чакане, не отказ.
window.MILA_ZNAE_USLUGA = function(u){
  if(!u) return true;
  return !!(ПОНИВА && ПОНИВА[u]);
};
var ДРУГИЯТ = null; // най-добрият час в другия салон, когато е избран град
var РЪЧНО_ИЗБРАН = false; // жената сама ли натисна конкретен човек
var РЕДОВЕ = [];    // всички възможности: ниво × специалист

// Лицата на специалистките.
//
// Мила, 25.10.2026, след шест обаждания за две почивни дни: „Изобщо не
// могат да се ориентират в сайта. Много е объркано, нека да го направим
// с някакви картинки. Мила да се вижда лицето на Мила, да пише Мила."
// Една жена ѝ прати снимка на екрана с думите „никъде не пишело Мила":
// избрана беше Грета, защото тя е първата БЕЗ капаро, а имената живееха
// зад падащ списък, който жената не отвори.
//
// Адресите идват от темата, не оттук: `asset_url` го знае Liquid, затова
// секцията ги подава на `#usl-hora` като `data-snimki`.
var _лица = null;
function лицеНа(име){
  if(_лица === null){
    try{
      var к = document.getElementById('usl-hora');
      _лица = JSON.parse((к && к.getAttribute('data-snimki')) || '{}') || {};
    }catch(_){ _лица = {}; }
  }
  if(!име) return '';
  // Базата пази име с фамилия („Христина Христова"), ключовете са лични.
  // Същото правило като `отКарта` в api/_imena.js.
  var к = Object.keys(_лица);
  for(var i = 0; i < к.length; i++)
    if(String(име).indexOf(к[i]) === 0) return _лица[к[i]];
  return '';
}
// Празен низ, когато името не се показва (премахване на стар грим) или
// когато лицето липсва: редът просто остава без снимка.
function лицеТаг(име){
  if(БЕЗ_ИМЕ) return '';
  var а = лицеНа(име);
  return а ? '<img class="usl-lice" src="' + а + '" alt="" width="52" height="52" loading="lazy">' : '';
}

function прочетиУслугата(){
  УСЛУГА = сек.dataset.usluga;
  БЕЗ_ИМЕ = сек.dataset.bez_ime === 'da';
  ПЪЛНА  = parseFloat(сек.dataset.pylna)  || 0;
  КАПАРО = parseFloat(сек.dataset.kaparo) || 0;
  ТРАЕНЕ = parseInt(сек.dataset.traene,10)|| 60;

  // Избор на зони от страницата за лазер. Идва в адреса, за да може жената
  // да се върне назад и да го намери, и да прати линка на приятелка.
  // Цената и траенето стават сборът, а зоните влизат в бележката на часа.
  (function(){
    var п = new URLSearchParams(location.search);
    var зони = п.get('zoni'), сума = parseFloat(п.get('suma')), минути = parseInt(п.get('minuti'), 10);
    if(!зони || !(сума > 0) || !(минути > 0)) return;
    ЗОНИ = зони;
    ПО_ЗОНИ = true;
    // Пакетът от шест. Ади трябва да види в картона кой сеанс е този:
    // при шест посещения за една платена сума инак не се разбира докъде
    // е стигнала жената.
    var бройСеанси = parseInt(п.get('sesii'), 10);
    if(бройСеанси > 1) ПАКЕТ = бройСеанси;
    // Името носи КОИ зони, не само колко.
    //
    // Жена, избрала подмишници, стигаше до страница, озаглавена „Лазерна
    // епилация · горна устна", със снимка на крака — защото носещият
    // продукт е друг. В поръчката пък пишеше „1 зона". И двете са лоши:
    // тя не вижда своя избор никъде. 11.10.2026.
    //
    // До три зони ги изброяваме. Повече не се четат на един ред, затова
    // тогава остава броят.
    var списъкЗони = зони.split('|').filter(Boolean);
    var брой = списъкЗони.length;
    ИМЕ_ЗОНИ = 'Лазерна епилация · ' + (брой <= 3
      ? списъкЗони.join(', ').toLowerCase()
      : брой + ' зони');
    // Заглавието горе също следва избора, инак страницата казва едно, а
    // поръчката друго.
    (function(){
      var з = document.querySelector('.usl-ime');
      if(з) з.innerHTML = ИМЕ_ЗОНИ.replace(' · ', '&nbsp;· ');
      try{ document.title = ИМЕ_ЗОНИ + ' – Mila Savage Beauty'; }catch(e){}
    })();
    ПЪЛНА = сума;
    ТРАЕНЕ = минути;
    // КАПАРО ПРИ ЗОНИТЕ: НЯМА.
    //
    // Дотук стоеше „20% нагоре, поне 10 €" — правилото на Ади от
    // 24.09.2026. То се смята ТУК, в браузъра, а не идва от базата:
    // затова нулирането на 22.10 не го достигна и лазерът продължаваше
    // да иска капаро, докато всичко останало вече беше без.
    //
    // Антонио, 22.10.2026: „при всички други махаме капарото, навсякъде
    // за всички услуги." Лазерът е при Грета, значи влиза в „всички
    // други". Капаро остава само при Мила, а тя не прави лазер.
    //
    // 2.11.2026: вече 100 € от 300 € нагоре, виж капароЗаЗоните().
    КАПАРО = капароЗаЗоните();
    ОСТАТЪК = ПЪЛНА - КАПАРО;
  })();
  // Страницата на лазера отваря БЕЗ избрани зони. Дотогава горе стоеше
  // цената на носещата услуга — 256 € за цяло тяло — и изглеждаше, че
  // нещо вече е избрано. Антонио, 08.10.2026: „влизам и автоматично ми е
  // избрано нещо, не е ясно."
  if(document.getElementById('laz-vgraden')){
    document.body.classList.add('laz-stranica');
  }
  if(document.getElementById('laz-vgraden') && !ПО_ЗОНИ){
    var отЦена = parseFloat(сек.dataset.ot_cena || '') || 13;
    ПЪЛНА = отЦена;
    // Без избрани зони и без капаро: виж по-горе.
    КАПАРО = 0;
    ОСТАТЪК = ПЪЛНА;
    document.body.classList.add('laz-bez-izbor');
    // Цената е нарисувана от сървъра като 256 €, колкото е носещата
    // услуга. Пренаписваме я веднага, иначе за миг стои грешна.
    // Цената стои в <b id="usl-cena">, не в текста на абзаца: първия път
    // сложих „от €13" пред него и на екрана излязоха две цени една до
    // друга — 13 и 256.
    var ц0 = document.getElementById('usl-cena');
    if(ц0) ц0.textContent = '\u20AC' + Math.round(ПЪЛНА);
    var т0 = document.getElementById('usl-traene');
    if(т0) т0.hidden = true;
  }

  ИМЕ    = сек.dataset.ime;
  ПРОМО_КОД = кодътОтАдреса();
  ОСТАТЪК= Math.max(0, ПЪЛНА - КАПАРО);
  // Метафийлдът го няма при повечето процедури и Liquid праща „null".
  // JSON.parse не гърми на това — връща null — и после НИВА.length убиваше
  // целия скрипт още преди първата заявка. Оттам „Свалям…" завинаги.
  var х; try{ х = JSON.parse(сек.dataset.niva || '[]'); }catch(e){ х = null; }
  НИВА = Array.isArray(х) ? х : [];
  ИЗБРАНО = УСЛУГА;
}
прочетиУслугата();

// ТЕЛЕФОНЪТ ПО САЛОН. Ади, 13.10.2026: пробиването на уши в Стара Загора
// се записва само по телефона на Христина, 0889926005.
//
// Дотук всяко съобщение на сайта даваше софийския номер. Тоест жена,
// отворила страница за Стара Загора и видяла „няма свободни часове",
// звънеше в София за час при Христина.
//
// Градът се познава по името на услугата („· Стара Загора"), а когато
// съобщението вече знае за кой салон говори, той се подава изрично.
var ТЕЛЕФОНИ = { 'София': '+359885041696', 'Стара Загора': '+359889926005' };
function телЗа(град){
  if(ТЕЛЕФОНИ[град]) return ТЕЛЕФОНИ[град];
  return /Стара Загора/.test(ИМЕ || '') ? ТЕЛЕФОНИ['Стара Загора'] : ТЕЛЕФОНИ['София'];
}
function телПис(град){
  return телЗа(град).replace('+359', '0').replace(/^0(\d{3})(\d{3})(\d{3})$/, '0$1 $2 $3');
}
function телЛинк(град){
  return '<a href="tel:' + телЗа(град) + '">' + телПис(град) + '</a>';
}

var МЕСЕЦИ=['януари','февруари','март','април','май','юни','юли','август','септември','октомври','ноември','декември'];
var ДНИ=['неделя','понеделник','вторник','сряда','четвъртък','петък','събота'];
var КРАТКИ_ДНИ=['нд','пн','вт','ср','чт','пт','сб'];
var ДНИ_КРАТКО=['нд','пн','вт','ср','чт','пт','сб'];

var избор = { specialist:null, mesec:null, den:null, chas:null, staff_id:null };
var часовеПоДен = {};
// кои стъпки са свършени и затова свити
var свито = { den:false, chas:false };
var редДни = [];
var ВИП = [];
// Кои услуги са в играта точно сега. На страница за цяло семейство
// („Премахване на стрии") нивата са 26, но щом жената е избрала зона и
// брой сеанси, при нея остават само нейните два варианта: София и Стара
// Загора. Тогава списъкът „При кого" показва ДВА реда, а градът идва от
// човека, вместо да има отделен ред „Салон".
// null значи „без ограничение": така работят обикновените страници.
var ДОПУСТИМИ = null;
var таймер = null;

var $ = function(id){ return document.getElementById(id); };
var евро = function(n){ return '€' + Math.round(n); };

// ─── Преди календара: стар грим и снимка ─────────────────────────────
// Три клиентки за един ден дойдоха с вежди, неподходящи за процедурата:
// никоя не беше прочела имейла. Затова правилото стои тук, пред
// календара, и не може да се прескочи:
//   микроблейдинг без стар перманентен грим: записва се нормално;
//   микроблейдинг със стар перманентен грим: онлайн не се записва;
//   поддръжка: само след качена снимка на веждите.
var КРАЙ    = 'https://mila-crm.vercel.app';   // нашите крайни точки
var СНИМКИ_АДРЕС = КРАЙ + '/api/snimka';
var ТРИАЖ = { вид:null, стар:null, снимка:null };

function видТриаж(){
  // Видът следва ИЗБРАНОТО НИВО, не заглавието на страницата. Откакто
  // поддръжката е вътре в микроблейдинга, заглавието е едно и също за
  // петте нива. Жена, избрала поддръжка, получаваше въпроса „имаш ли
  // стар грим" и на „да" ѝ се казваше, че часът не се записва онлайн —
  // а тя идва точно защото има стар грим, наш. Видяно 08.10.2026.
  var и = String(ИМЕ || '').toLowerCase();

  // Страницата решава ПЪРВА, преди нивото.
  //
  // На премахването нивата се казват „вежди · първична", „вежди · 2-ра".
  // Думата „първична" там значи първи сеанс лазер, не първи микроблейдинг,
  // а долният ред я хващаше и искаше снимка и въпрос за стар грим — на
  // страница, чиято цел е точно да махне стария грим.
  // Ади го видя на 09.10.2026: „трябва да се махне това да качват снимки,
  // няма нужда."
  // Татуировка над 20 кв. см не се цени на сляпо: нужна е снимка и
  // уговорка. Ади, 12.10.2026: „над 20 кв.см по договаряне след снимка."
  // Четем направо избрания чип, защото този избор няма услуга зад себе си.
  try{
    var избран = document.querySelector('.sem-chip.on');
    if(избран && /над\s*20/.test(избран.textContent || '')) return 'po_dogovaryane';
  }catch(e){}

  if(/премахване на стар|премахване с лазер|татуировк/.test(и)) return null;

  var ниво = '';
  try{
    var р = (РЕДОВЕ || []).filter(function(x){ return x.usluga === ИЗБРАНО; })[0];
    ниво = String((р && р.etiket) || '').toLowerCase();
  }catch(e){ ниво = ''; }
  if(/поддръжка|другаде/.test(ниво)) return 'poddrazhka';
  if(/първичн|vip|вип|обикновен/.test(ниво)) return 'mikroblejding';

  if(/поддръжка/.test(и)) return 'poddrazhka';
  // Премахването на стар грим НЕ иска снимка.
  //
  // На 07.10 Ади каза, че иска, и го сложихме. На 09.10 се отказа:
  // „махни вече изискването на снимка за лазер." Освен това текстът
  // отдолу говореше за поддръжка, а жената е дошла за премахване —
  // две различни неща с един и същ надпис.
  //
  // Киселината я няма на сайта, затова не я изброявам тук.
  if(/премахване на стар|премахване с лазер/.test(и)) return null;
  if(/микроблейдинг/.test(и)) return 'mikroblejding';
  return null;
}
function триажГотов(){
  if(ТРИАЖ.вид === 'po_dogovaryane') return false;   // няма онлайн час
  if(ТРИАЖ.вид === 'poddrazhka') return !!ТРИАЖ.снимка;
  // Стар грим: вече се записва онлайн, но само след снимка — точно
  // както поддръжката. Антонио, 16.10.2026. Дотук този случай изобщо
  // не стигаше до календар: пращаше човека в Viber или WhatsApp, а
  // снимката оставаше в нечий телефон.
  if(ТРИАЖ.вид === 'mikroblejding')
    return ТРИАЖ.стар === 'не' || (ТРИАЖ.стар === 'да' && !!ТРИАЖ.снимка);
  return true;
}
(function(){
  var ст = document.createElement('style');
  ст.textContent =
    // Изборът на човек ОСТАВА видим, докато чакаме отговор или снимка.
    // Антонио, 08.10.2026: „избирам поддръжка и автоматично ми се скрива
    // всичко, не е ясно къде съм." Жена, която иска Стара Загора, трябва
    // първо да види Христина, а после да качи снимка — не обратното.
    // Скриват се само датата, часът и плащането: те нямат смисъл, преди
    // да знаем, че процедурата изобщо е възможна.
    '.triazh-chaka #rez-red-den,.triazh-chaka #rez-dni,.triazh-chaka #rez-red-chas,' +
    '.triazh-chaka #rez-chasove,.triazh-chaka #rez-potvardi{display:none!important}' +
    // ЧЕРЕН БЛОК, БЯЛ ТЕКСТ. Антонио, 30.10.2026: „да е още по-ярко и
    // още по-лесно да се вижда… да е черен фон и това цялото да пулсира.
    // Буквално да им се набива."
    //
    // Причината е проста: това е единственият въпрос на екрана, който
    // може да ОТМЕНИ часа. Отговори ли грешно, идва на процедура, която
    // не може да ѝ се направи. Досега беше бежов блок между бежови
    // блокове и окото го подминаваше.
    // ТРИ ЦВЯТА, НЕ ПОВЕЧЕ. Антонио, 30.10.2026: „първо има едно като
    // оранжево, после има това златното… дай да има кафяво, черно и бяло."
    // Златната рамка върху черното светеше като четвърти цвят — оранжево.
    // Махната е: черен блок, бял текст, а кафявото остава само за двете
    // неща, които трябва да се натиснат — изхода „сгреших" и пулсирането.
    '.rez-triazh{border:0;background:var(--mila-vuglen,#2b2723);padding:20px 18px 18px;margin:0 0 22px}' +
    '.rez-triazh h3{font-size:18.5px;margin:0 0 10px;color:#fff;font-weight:600}' +
    // Бутоните върху чисто черното: рамката им беше топло черна и се
    // сливаше с фона.
    '.rez-triazh .t-b button,.rez-triazh label.t-kachi{border-color:#fff}' +
    '.rez-triazh p{margin:0 0 12px;font-size:15px;line-height:1.55;color:rgba(255,255,255,.88)}' +
    '.rez-triazh .t-b{display:flex;gap:8px;flex-wrap:wrap}' +
    '.rez-triazh .t-b button,.rez-triazh .t-b a,.rez-triazh label.t-kachi{flex:1;min-width:130px;text-align:center;' +
    'padding:12px 10px;border:1px solid #241E19;background:#fff;color:#241E19;font:inherit;font-size:14px;cursor:pointer;text-decoration:none}' +
    // Инверсията на hover беше тъмно върху тъмно — бутонът изчезваше.
    '.rez-triazh .t-b button:hover,.rez-triazh label.t-kachi:hover{background:#B98A50;color:#241E19;border-color:#B98A50}' +
    '.rez-triazh .t-spri{border-left:3px solid #B98A50;padding-left:12px;color:rgba(255,255,255,.88)}' +
    '.rez-triazh .t-red{display:flex;justify-content:space-between;align-items:center;gap:10px;font-size:14.5px}' +
    '.rez-triazh .t-red img{width:52px;height:52px;object-fit:cover;border:1px solid #d8cfc3}' +
    // „смени" беше кафяво върху черно — четвъртият цвят, който Антонио
    // хвана на 30.10.2026. Бяло е, като всичко друго в блока; подчертаването
    // стига, за да личи, че се натиска.
    '.rez-triazh .t-smeni{background:none;border:0;color:#fff;text-decoration:underline;cursor:pointer;font:inherit;font-size:13.5px;text-underline-offset:3px}' +
    // „Сгреших, нямам стар грим" е изходът от грешен отговор. Беше златно
    // и дребно, тоест най-незабележимото нещо в блока — а жена, която
    // е цъкнала „Да, имам" по погрешка, оттук нататък е спряна и иска да
    // се върне. Антонио, 30.10.2026: „това искам да е с бяло и с по-големи
    // букви." Затова само ТОЗИ изход е бял и едър; другите „смени" си
    // остават дребни, защото не спират никого.
    '.rez-triazh .t-sgreshih .t-smeni{font-size:16px}' +
    '.rez-triazh .t-greshka{color:#FF9B8A;font-size:13.5px;margin-top:8px}' +
    '.rez-triazh .t-red,.rez-triazh .t-snimka-tekst,.rez-triazh .t-snimka-tekst em{color:rgba(255,255,255,.88)}' +
    '.rez-triazh .t-sgreshih{margin-bottom:0}' +
    '.rez-triazh input[type=file]{display:none}' +
    // Предпазна мрежа, не поправка: щом надписът „При кого и кога" го
    // няма, кутията без избран човек би останала празна рамка. Проверено
    // на 30.10.2026 — в живия поток тя почти винаги носи избраната
    // специалистка със снимка, тоест това правило рядко се задейства.
    // Празното място, което Антонио видя, се реши с друго: календарът
    // вече стои точно там (виж mila-zapazi.liquid).
    '.usl-glava:has(.usl-glava-izbor:empty){display:none}' +
    // Пулсирането беше тъмна рамка върху бежово — почти не личеше.
    // Сега е златно сияние върху черно и върви по-дълго.
    '@keyframes milaPuls{0%,100%{box-shadow:0 0 0 0 rgba(185,138,80,0)}' +
    '50%{box-shadow:0 0 0 12px rgba(185,138,80,.34)}}' +
    '.rez-triazh.t-pulsira{animation:milaPuls 1.5s ease-in-out 5}' +
    '@media (prefers-reduced-motion:reduce){.rez-triazh.t-pulsira{animation:none}}';
  document.head.appendChild(ст);
})();

function кутияТриаж(){
  var к = $('rez-triazh');
  if(к) return к;
  к = document.createElement('div');
  к.id = 'rez-triazh'; к.className = 'rez-triazh';
  // Снимката идва СЛЕД „при кого", не преди него.
  //
  // Антонио, 25.10.2026: „Първо избират поддръжка, избират при кой, и
  // след това им излиза за снимката." Дотук кутията се вмъкваше НАД
  // списъка с хора и жената се озоваваше пред „Качи снимка", преди да е
  // видяла при кого изобщо отива. Това отменя подредбата от 08.10.2026:
  // тогава изборът на човек само остана видим, но пак беше втори.
  // Антонио, 29.10.2026: въпросът за стария грим да е първото нещо, над
  // Мила, Грета и Христина. Обръща подредбата от 25.10.2026; тогава
  // кутията беше горе и жената виждаше Качи снимка, преди да е избрала
  // при кого. Сега въпросът е два бутона, а качването идва чак след Да.
  var хора = $('usl-hora');
  if(хора && хора.parentNode){
    хора.parentNode.insertBefore(к, хора);
    return к;
  }
  var преди = $('rez-red-hora') || $('rez-hora') || $('rez-red-den') || $('rez-dni');
  if(преди && преди.parentNode) преди.parentNode.insertBefore(к, преди);
  return к;
}
// Коя зона пита въпросникът.
//
// Триажът тръгва от НИВОТО: „първична процедура" дава микроблейдинг.
// Само че и микропигментацията на устни има ниво „първична", затова на
// страницата за УСТНИ жената виждаше „Имаш ли стар перманентен грим на
// веждите?", а после „Без стар перманентен грим на веждите." Намерено
// на 21.10.2026, докато се пробваше пътят от промоцията за устни.
//
// Въпросът сам по себе си е верен — стар грим на устните също пречи на
// новия. Грешна беше само думата.
function зоната(){
  return /устн/i.test(String(ИМЕ || '')) ? 'устните' : 'веждите';
}

// Кутията пулсира, докато нещо липсва.
//
// Антонио, 25.10.2026: „Натискам Запази час, но това за снимката трябва
// да ми пулсира цялото." Жената натиска бутона, календарът не се отваря
// и тя не разбира защо: отговорът стои в кутията отгоре, но изглежда
// като пореден текст. Анимацията спира сама и я няма при включено
// „по-малко движение" в телефона.
function пулсирай(){
  var к = $('rez-triazh');
  if(!к) return;
  к.classList.remove('t-pulsira');
  void к.offsetWidth;           // рестарт на анимацията
  к.classList.add('t-pulsira');
}
function рисувайТриаж(){
  рисувайТриажВътре();
  if(!триажГотов()) пулсирай();
}
function рисувайТриажВътре(){
  var к = кутияТриаж();
  // Кутията се прави първия път, когато списъкът с хората още го няма,
  // и тогава пада другаде. Затова мястото се налага при всяко рисуване.
  var горе = $('usl-hora');
  if(горе && горе.parentNode && горе.previousElementSibling !== к){
    try{ горе.parentNode.insertBefore(к, горе); }catch(e){}
  }
  if(!ТРИАЖ.вид){ к.hidden = true; document.body.classList.remove('triazh-chaka'); return; }
  к.hidden = false;
  // Класът седи на body, не на #rez. На продуктовата страница
  // #usl-hora е ИЗВЪН #rez, затова вложеното правило не го хващаше
  // и календарът си стоеше отворен, преди да има отговор.
  document.body.classList.toggle('triazh-chaka', !триажГотов());
  var тел = '' + телЛинк() + '';

  // Татуировка над 20 кв. см: цената се определя по снимка, затова тук
  // няма часове, а запитване. Снимката тръгва през същия край, който
  // ползва и поддръжката. Ади, 12.10.2026.
  if(ТРИАЖ.вид === 'po_dogovaryane'){
    if(ТРИАЖ.пратено){
      к.innerHTML = '<div class="t-red t-snimka-gotova">' +
        '<span class="t-snimka-tekst"><b>\u2713 Получихме запитването</b>' +
        '<em>Ще ти се обадим с цена и свободен час.</em></span></div>';
      return;
    }
    к.innerHTML = '<h3>Над 20 кв. см: цената се уговаря по снимка</h3>' +
      '<p>Големите татуировки са различни по мастило, плътност и цвят. ' +
      'Затова цената и броят сеанси се казват след снимка, не предварително.</p>' +
      (ТРИАЖ.снимка
        ? '<div class="t-red t-snimka-gotova">' +
          '<img class="t-snimka-pregled" src="' + ТРИАЖ.преглед + '" alt="Качената снимка">' +
          '<span class="t-snimka-tekst"><b>\u2713 Снимката е прикачена</b></span>' +
          '<button type="button" class="t-smeni" data-triazh="nulirai">смени</button></div>'
        : '<div class="t-b"><label class="t-kachi">Качи снимка<input type="file" accept="image/*" id="t-fail"></label></div>') +
      '<div class="t-pole"><input type="text" id="dog-ime" placeholder="Име и фамилия" autocomplete="name"></div>' +
      '<div class="t-pole"><input type="tel" id="dog-tel" placeholder="0888 123 456" autocomplete="tel"></div>' +
      '<div class="t-b"><button type="button" id="dog-prati">Изпрати запитване</button>' +
      '<a href="viber://chat?number=%2B359885041696">или по Viber</a></div>' +
      '<div class="t-greshka" id="t-greshka"></div>';
    return;
  }

  if(ТРИАЖ.вид === 'mikroblejding'){
    if(ТРИАЖ.стар === 'не'){
      к.innerHTML = '<div class="t-red"><span>Без стар перманентен грим на ' + зоната() + '.</span>' +
        '<button type="button" class="t-smeni" data-triazh="nulirai">смени</button></div>';
      return;
    }
    if(ТРИАЖ.стар === 'да'){
      // Снимката се качва ТУК, не се праща по Viber или WhatsApp.
      //
      // Дотук имаше две различни врати за едно и също нещо: поддръжката
      // искаше „Качи снимка" на сайта, а старият грим пращаше човека в
      // Viber или WhatsApp. Снимката от сайта влиза в CRM-а и стои на
      // картона; снимката в чат остава в нечий телефон и се губи.
      // Антонио, 16.10.2026: „Трябва да е еднакво за двете."
      //
      // WhatsApp махнат нарочно: номерът е личният телефон на Мила, а не
      // на салона, и точно оттам ѝ пишеха непознати.
      к.innerHTML = '<h3>Първо трябва да видим ' + зоната() + ' ти</h3>' +
        '<p class="t-spri">При стар перманентен грим старият пигмент променя цвета и формата ' +
        'на новия. Затова часът се запазва само след снимка. Ако се окаже, че първо трябва ' +
        'премахване, ще ти се обадим и ще преместим часа, без да губиш капарото.</p>' +
        '<p>Качи снимка на ' + зоната() + ', отблизо и на дневна светлина.</p>' +
        (ТРИАЖ.снимка
          ? '<div class="t-red t-snimka-gotova">' +
            '<img class="t-snimka-pregled" src="' + ТРИАЖ.преглед + '" alt="Качената снимка">' +
            '<span class="t-snimka-tekst"><b>✓ Снимката е прикачена</b></span>' +
            '<button type="button" class="t-smeni" data-triazh="nulirai">смени</button></div>'
          : '<div class="t-b"><label class="t-kachi">Качи снимка<input type="file" accept="image/*" id="t-fail"></label></div>') +
        '<div class="t-greshka" id="t-greshka"></div>' +
        '<p class="t-sgreshih"><button type="button" class="t-smeni" data-triazh="nulirai">сгреших, нямам стар грим</button></p>';
      return;
    }
    к.innerHTML = '<h3>Преди да избереш час</h3>' +
      '<p>Имаш ли стар перманентен грим на ' + зоната() + '? Дори избледнял или правен преди години.</p>' +
      '<div class="t-b"><button type="button" data-triazh="ne">Не, нямам</button>' +
      '<button type="button" data-triazh="da">Да, имам</button></div>';
    return;
  }
  // поддръжка
  if(ТРИАЖ.снимка){
    // Антонио качи снимка и попита „къде отиде". Отговорът беше тук, но
    // миниатюрата беше малка и без рамка, а текстът не казваше, че е
    // стигнала докъдето трябва. Сега се вижда.
    к.innerHTML = '<div class="t-red t-snimka-gotova">' +
      '<img class="t-snimka-pregled" src="' + ТРИАЖ.преглед + '" alt="Качената снимка">' +
      '<span class="t-snimka-tekst"><b>\u2713 Снимката е прикачена</b>' +
      '<em>Специалистът я вижда преди часа.</em></span>' +
      '<button type="button" class="t-smeni" data-triazh="nulirai">смени</button></div>';
    return;
  }
  к.innerHTML = '<h3>Преди да избереш час: снимка на веждите</h3>' +
    '<p>Поддръжка се записва само след снимка. По нея специалистът преценява дали поддръжката е ' +
    'подходяща за твоите вежди, или е нужно друго. Снимай ги отблизо, на дневна светлина, без грим.</p>' +
    '<div class="t-b"><label class="t-kachi">Качи снимка<input type="file" accept="image/*" id="t-fail"></label></div>' +
    '<div class="t-greshka" id="t-greshka"></div>';
}
function смалиСнимката(файл){
  return new Promise(function(ок, не){
    var ч = new FileReader();
    ч.onerror = не;
    ч.onload = function(){
      var и = new Image();
      и.onerror = не;
      и.onload = function(){
        var макс = 1600, к = Math.min(1, макс / Math.max(и.width, и.height));
        var пл = document.createElement('canvas');
        пл.width = Math.round(и.width * к); пл.height = Math.round(и.height * к);
        пл.getContext('2d').drawImage(и, 0, 0, пл.width, пл.height);
        ок(пл.toDataURL('image/jpeg', 0.85));
      };
      и.src = ч.result;
    };
    ч.readAsDataURL(файл);
  });
}
// Слуша се документът, а не #rez: картата се вмъква до #usl-hora, който
// на продуктовата страница е извън #rez. Цъкаше се и нищо не стигаше.
document.addEventListener('click', function(е){
  var б = е.target.closest && е.target.closest('[data-triazh]'); if(!б) return;
  var к = б.dataset.triazh;
  if(к === 'ne') ТРИАЖ.стар = 'не';
  if(к === 'da') ТРИАЖ.стар = 'да';
  if(к === 'nulirai'){ ТРИАЖ.стар = null; ТРИАЖ.снимка = null; ТРИАЖ.преглед = null; }
  рисувайТриаж();
  if(триажГотов()) слезиПриЧасовете && (function(){ var ц=$('usl-hora')||$('rez-dni'); if(ц) ц.scrollIntoView({block:'nearest',behavior:'smooth'}); })();
});
// Изпращане на запитване за татуировка над 20 кв. см.
document.addEventListener('click', function(е){
  if(!е.target || е.target.id !== 'dog-prati') return;
  var и = $('dog-ime'), тел = $('dog-tel'), гр = $('t-greshka');
  var име = (и && и.value || '').trim(), н = (тел && тел.value || '').trim();
  function кажи(т){ if(гр) гр.textContent = т || ''; }
  if(име.length < 2){ кажи('Напиши името си.'); return; }
  if(н.replace(/\D/g,'').length < 9){ кажи('Напиши телефон, за да ти кажем цената.'); return; }
  кажи('');
  е.target.disabled = true; е.target.textContent = 'Изпращам…';
  fetch(КРАЙ + '/api/zapitvane', {
    method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({
      liniya:'procedura', ime:име, telefon:н, izvor:(typeof window.MILA_IZVOR==='function' ? (window.MILA_IZVOR().izvor||'') : ''),
      vapros:'Премахване на татуировка над 20 кв. см. Цена по договаряне след снимка.'
             + (ТРИАЖ.снимка ? '\nСнимка: ' + ТРИАЖ.снимка : '\nБез снимка.')
    })
  })
  .then(function(р){ return р.json().then(function(о){ if(!р.ok) throw new Error(о.greshka||'грешка'); return о; }); })
  .then(function(){ ТРИАЖ.пратено = true; рисувайТриаж(); })
  .catch(function(г){
    кажи('Не се изпрати: ' + (г.message || 'опитай пак или се обади.'));
    е.target.disabled = false; е.target.textContent = 'Изпрати запитване';
  });
});

document.addEventListener('change', function(е){
  if(е.target.id !== 't-fail' || !е.target.files || !е.target.files[0]) return;
  var гр = $('t-greshka'); var лбл = е.target.parentNode;
  лбл.firstChild.textContent = 'Качвам…';
  смалиСнимката(е.target.files[0])
    .then(function(данни){
      return fetch(СНИМКИ_АДРЕС, { method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ data: данни, usluga: ИМЕ }) })
        .then(function(р){ return р.json().then(function(о){ if(!р.ok || !о.put) throw new Error(о.greshka||'грешка'); return { о:о, данни:данни }; }); });
    })
    .then(function(х){ ТРИАЖ.снимка = х.о.put; ТРИАЖ.преглед = х.данни; рисувайТриаж(); })
    .catch(function(){
      лбл.firstChild.textContent = 'Качи снимка';
      if(гр) гр.innerHTML = 'Снимката не се качи. Опитай пак или я изпрати на Viber на ' +
        '' + телЛинк() + '.';
    });
});
// ─────────────────────────────────────────────────────────────────────

function датаБГ(iso){
  var d = new Date(iso + 'T00:00:00');
  return d.getDate() + ' ' + МЕСЕЦИ[d.getMonth()];
}
function денОтИсо(iso){
  return ДНИ[new Date(iso + 'T00:00:00').getDay()];
}

// ---------------------------------------------------------------- базата
function викни(име, тяло){
  return fetch(БАЗА + '/rest/v1/rpc/' + име, {
    method:'POST',
    headers:{apikey:КЛЮЧ, Authorization:'Bearer '+КЛЮЧ, 'Content-Type':'application/json'},
    body: JSON.stringify(тяло || {})
  }).then(function(r){
    if(!r.ok) return r.text().then(function(t){ throw new Error(r.status + ' ' + t.slice(0,120)); });
    return r.json();
  });
}

// Софийско време → точния миг, който базата пази.
// България е на +02 през зимата и +03 през лятото.
function отместванеНаСофия(миг){
  var ф = new Intl.DateTimeFormat('en-US', {timeZone:'Europe/Sofia',
    year:'numeric', month:'2-digit', day:'2-digit',
    hour:'2-digit', minute:'2-digit', second:'2-digit', hour12:false});
  var ч = {}; ф.formatToParts(миг).forEach(function(p){ ч[p.type] = p.value; });
  return Date.UTC(+ч.year, +ч.month - 1, +ч.day, +ч.hour % 24, +ч.minute, +ч.second) - миг.getTime();
}
function софийскоВUTC(ден, час){
  var д = String(ден).split('-').map(Number), т = String(час).split(':').map(Number);
  var предположение = Date.UTC(д[0], д[1] - 1, д[2], t0(т,0), t0(т,1), 0);
  var миг = предположение;
  for(var i = 0; i < 2; i++) миг = предположение - отместванеНаСофия(new Date(миг));
  return new Date(миг);
}
function t0(масив, к){ return масив[к] || 0; }

function свободни(usluga){
  // Почистването на изтеклите заделяния стоеше ТУК и се викаше по веднъж
  // за всяко ниво. На стриите нивата са трийсет и две, тоест трийсет и
  // две еднакви заявки при всяко отваряне на страницата. Преместено е в
  // всичкиНива, където се вика веднъж. Антонио, 19.10.2026.

  // Питаме Google в момента на отварянето, не копие в базата.
  //
  // Старата функция svobodni_chasove смяташе по нашия препис на
  // заетостта и гледаше трийсет дни напред. На 08.10.2026 това продаде
  // час на Mariya Georgieva за 13 октомври 12:15, докато Грета прави
  // цяло тяло от 11:00 до 13:00. Същия ден декември изглеждаше напълно
  // затворен, защото беше отвъд трийсетте дни.
  //
  // Ако новото не отговори, НЕ падаме обратно към старото: по-добре
  // празен календар и телефон, отколкото продаден зает час.
  // При зоните сървърът трябва да знае истинското траене на сбора: виж
  // `поискани` в api/svobodni.js. Иначе прозорецът е колкото носителя.
  return fetch(КРАЙ + '/api/svobodni?usluga=' + encodeURIComponent(usluga) +
      (ПО_ЗОНИ && ТРАЕНЕ > 0 ? '&minuti=' + Math.round(ТРАЕНЕ) : ''))
    .then(function(r){
      if(!r.ok) return r.text().then(function(t){ throw new Error(r.status + ' ' + t.slice(0,140)); });
      return r.json();
    })
    .then(function(о){
      if(о && о.greshka) throw new Error(о.greshka);
      if(о && о.trae) ТРАЕНЕ_НА[usluga] = Number(о.trae) || null;
      return (о && о.chasove) || [];
    });
}

// Кой колко капаро взима, за всички нива наведнъж. Отделна заявка,
// защото капарото зависи от човека, а не само от процедурата, но една:
// три нива правеха три излишни отивания до базата.
function капарата(услуги){
  return fetch(БАЗА + '/rest/v1/rpc/kaparata_mnogo', {
    method:'POST',
    headers:{apikey:КЛЮЧ, Authorization:'Bearer '+КЛЮЧ, 'Content-Type':'application/json'},
    body: JSON.stringify({ p_services: услуги })
  }).then(function(r){ return r.ok ? r.json() : []; }).catch(function(){ return []; });
}

// всички нива наведнъж: обикновен час и по-бързите версии
function всичкиНива(){
  var списък = НИВА.length ? НИВА : [{usluga:УСЛУГА, etiket:''}];
  var услуги = списък.map(function(н){ return н.usluga; });

  // Изтеклите заделяния се махат точно преди да се смятат свободните,
  // иначе час, изоставен на касата, стои зает до следващото заделяне.
  // Веднъж за цялата страница, не веднъж за ниво.
  викни('pochisti_zadarzhaniyata').catch(function(){});

  // Всяко ниво се пази само за себе си.
  //
  // Дотук стоеше гол Promise.all: паднеше ли ЕДНО ниво, падаше всичко и
  // страницата пишеше „Няма свободни часове напред" — лъжа, докато в
  // базата стоят хиляда свободни часа. При стриите нивата станаха
  // трийсет и две на 19.10.2026 и един провал от трийсет и две е
  // достатъчен. Христина го видя на „гръб · един сеанс".
  //
  // Сега паднало ниво връща празен списък, както ниво без свободен час,
  // и останалите се показват. Ако паднат ВСИЧКИ, грешката тръгва нагоре:
  // тогава проблемът е общ и човекът трябва да види телефона, а не
  // празен календар.
  var паднали = 0, първата = null;
  return Promise.all([
    Promise.all(списък.map(function(н){
      return свободни(н.usluga)
        .then(function(р){ return {ниво:н, redove:р}; })
        .catch(function(e){
          паднали++; първата = първата || e;
          return {ниво:н, redove:[]};
        });
    })),
    капарата(услуги)
  ]).then(function(два){
    if(паднали === списък.length) throw (първата || new Error('нито едно ниво не отговори'));
    var капари = два[1] || [];
    return два[0].map(function(н){
      н.kapara = капари.filter(function(к){ return к.usluga === н.ниво.usluga; });
      return н;
    });
  });
}

// Капарото при един човек за една услуга. Празно значи „не знаем" и се
// връща null: тогава редът не пише нищо, вместо да лъже с нула.
function капароНа(usluga, staff_id){
  var к = ПОКАПАРО[usluga + '|' + staff_id];
  return (к === null || к === undefined || isNaN(к)) ? null : Number(к);
}

// Капарото на реда, с две думи, под цената. „Без капаро" е същината на
// теста от 22.10.2026: онлайн не се плаща нищо, цялата сума е в салона.
function капароНадпис(р){
  if(р.kaparo === 0 && р.cena > 0) return '<small class="bez">без капаро</small>';
  if(р.kaparo > 0) return '<small>капаро ' + евро(р.kaparo) + '</small>';
  return '';
}

// ---------------------------------------------------------------- екран 1
// ОТКРИТИЯТ СПИСЪК НА ПРОДУКТА
//
// Антонио, 27.10.2026, по Clarity: за три дни 1818 гледания от телефон и
// само ~7% стигат до записването. Жената не разбира, че има свободни
// часове скоро, защото редовете със специалистките излизат чак след като
// избере „първична процедура".
//
// Затова на продукта редовете стоят ОТКРИТИ още с отварянето, но само за
// първичната: поддръжките остават зад чиповете, където си бяха. Натисне
// ли ред, първо се избира чипът (все едно го е натиснала тя), после
// човекът — така минаваме по същия път и нищо отдолу не се заобикаля.
var ПРЕДВАРИТЕЛНО = false;

// Чипът за първичната. Търси се по ДУМИТЕ на чипа, не по етикета на
// нивото: нивото се казва „обикновен час", а чипът — „първична процедура".
function чипътПървична(){
  var к = document.getElementById('sem-izbori');
  if(!к) return null;
  var н = null;
  [].forEach.call(к.querySelectorAll('.sem-chip'), function(ч){
    if(!н && /първичн/i.test(ч.dataset.stoynost || '')) н = ч;
  });
  return н;
}

// Коя услуга стои зад този чип. Минава се през вариантите на семейството,
// защото само там чипът и услугата се срещат.
function предварителнаУслуга(){
  var ч = чипътПървична();
  if(!ч) return null;
  var к = document.getElementById('sem-izbori');
  var Д; try{ Д = JSON.parse(к.dataset.izbori || 'null'); }catch(e){ return null; }
  var в = (Д && Д.varianti ? Д.varianti : []).filter(function(x){
    return x[ч.dataset.red] === ч.dataset.stoynost; })[0];
  return (в && в.usluga) ? в.usluga : null;
}

// Показваме ли откритите редове сега? Само на продукт, само докато НИЩО
// не е избрано, и НЕ когато жената идва с готово ниво в адреса (?nivo=):
// тогава тя вече е избрала и филтърът само би ѝ скрил нейното ниво.
//
// „Нищо не е избрано" се познава по чиповете, а не по класа
// `sem-bez-izbor`: класът идва от mila-semeystvo.js, който се зарежда с
// `defer`, докато този файл не е. Първия път проверявах класа и при
// бърз отговор от календара той още го нямаше — списъкът оставаше
// неразрязан и скрит. Избран чип носи `on`; няма ли такъв, нищо не е
// избрано, независимо кой файл е успял пръв.
function нищоНеЕИзбрано(){
  var к = document.getElementById('sem-izbori');
  if(!к) return false;
  if(!к.querySelector('.sem-chip')) return false;   // чиповете още ги няма
  return !к.querySelector('.sem-chip.on');
}

function даПоказвамОткрито(){
  if(!НИВА.length) return null;
  if(!нищоНеЕИзбрано()) return null;
  try{ if(new URLSearchParams(location.search).get('nivo')) return null; }catch(e){}
  return предварителнаУслуга();
}

// Рисува списъка ПОД бутона „Запази час".
//
// Редовете на екипа живеят вътре в екрана, който `mila-stapki.js` отваря
// с бутона. Първия път се опитах да ги извадя оттам през ДОПУСТИМИ —
// грешен слой: те си остават в затворения екран, а филтърът скриваше
// поддръжките и ВЪТРЕ в него. Затова тук се рисува СВОЙ списък, в самата
// страница, до бутона. Екранът не се пипа.
//
// Данните са същите: редовете идват от РЕДОВЕ, тоест от календара.
function нарисувайОткрития(){
  var пуск = document.querySelector('.st-pusk');
  if(!пуск || !пуск.parentNode) return false;      // екранът още го няма
  var u = предварителнаУслуга();

  // НЯМА „първична" → НЯМА списък.
  //
  // Антонио, 27.10.2026, след като минахме продуктите един по един: при
  // стриите изборът е зона × сеанси × салон (32 възможности), при
  // маникюра са тринайсет различни неща. Сложи ли се същият списък там,
  // той ИЗБИРА вместо жената: слага ѝ „ръце", когато тя иска корем, и ѝ
  // показва чужда цена. По-лошо от нищо.
  //
  // Затова там стои един ред без име, без цена и без избор. Казва ѝ само
  // това, което трябва да знае: че няма да чака месеци.
  if(!u) return самоДатата(пуск);
  // Списъкът НЕ изчезва след избор. Антонио, 27.10.2026: „ако натисна Х
  // отгоре, затварят ми се вече тия позиции с имената." Той е входът към
  // записването, а не отчет за състоянието: затвори ли се екранът, жената
  // трябва да завари същите три реда, както ги е заварила първия път.
  var редове = РЕДОВЕ.filter(function(r){ return r.usluga === u && r.staff; });
  if(!редове.length) return false;

  var к = document.getElementById('usl-otkrit');
  if(!к){
    к = document.createElement('div');
    к.className = 'usl-otkrit';
    к.id = 'usl-otkrit';
    пуск.parentNode.insertBefore(к, пуск.nextSibling);
  }
  к.innerHTML =
    '<div class="usl-otkrit-glava">Свободни часове при екипа</div>' +
    редове.map(function(r){
      return '<button type="button" class="usl-chovek usl-otkrit-red"' +
        ' data-hora="' + r.staff + '" data-usluga="' + r.usluga + '">' +
        лицеТаг(r.staff) +
        '<span><span class="kdo">' + r.staff + '</span>' +
        '<span class="kade">' + (r.grad ? r.grad + ' · ' : '') +
        'първи свободен ' + датаБГ(r.parvi) + времеНаРеда(r) + '</span></span>' +
        '<span class="cena">' + ценаНаРеда(r) + капароНадпис(r) + '</span></button>';
    }).join('');
  ПРЕДВАРИТЕЛНО = true;
  return true;
}

document.addEventListener('click', function(е){
  var t = е.target.closest && е.target.closest('#usl-otkrit [data-hora]');
  if(!t) return;
  е.preventDefault();
  презЧипа(t);
});

// Един ред с най-ранния свободен час, за страниците с многоетажен избор.
// Нищо не се избира: това е надпис, не бутон.
function самоДатата(пуск){
  var най = null;
  Object.keys(ПОНИВА || {}).forEach(function(к){
    (ПОНИВА[к] || []).forEach(function(r){
      if(!r.den) return;
      if(!най || r.den < най) най = r.den;
    });
  });
  if(!най) return false;                      // часовете още не са дошли

  var к = document.getElementById('usl-otkrit');
  if(!к){
    к = document.createElement('div');
    к.className = 'usl-otkrit usl-otkrit-samo-data';
    к.id = 'usl-otkrit';
    пуск.parentNode.insertBefore(к, пуск.nextSibling);
  }
  к.className = 'usl-otkrit usl-otkrit-samo-data';
  к.innerHTML = '<p class="usl-nay-rano">' +
    '<span class="usl-nay-rano-etiket">Най-рано свободен час</span>' +
    '<b>' + денОтИсо(най) + ', ' + датаБГ(най) + времеОтВсички() + '</b></p>';
  return true;
}

// Екранът и чиповете се раждат по свое разписание: пробва се на къси
// отрязъци и се спира в мига, в който жената избере сама.
function опитайОткрито(){
  var опити = 0;
  var ч = setInterval(function(){
    опити++;
    var к = document.getElementById('sem-izbori');
    if(опити > 30 || (к && к.querySelector('.sem-chip.on'))){ clearInterval(ч); return; }
    if(нарисувайОткрития()) clearInterval(ч);
  }, 150);
}

function нарисувайХора(){
  // Всяко ниво при всеки специалист е отделен избор: една и съща работа,
  // различна цена и различно кога. Точно както го прави салонът.
  var редове = [];
  Object.keys(ПОНИВА).forEach(function(u){
    if(ДОПУСТИМИ && ДОПУСТИМИ.indexOf(u) < 0) return;
    var ниво = (НИВА.filter(function(н){ return н.usluga === u; })[0]) || {etiket:''};
    var видени = {};
    ПОНИВА[u].forEach(function(r){
      if(видени[r.staff]) return;
      видени[r.staff] = true;
      редове.push({ usluga:u, etiket:ниво.etiket, staff:r.staff, staff_id:r.staff_id,
                    cena:Number(r.cena)||0, parvi:r.den, grad:r.grad || '',
                    // Времето при ТОЗИ човек, не на услугата. Микроблейдингът
                    // е 60 минути в базата, но 180 при Грета и 120 при
                    // Христина. Ади, 16.10.2026: „Времето не е коригирано.
                    // За процедурите на Грета и Христина."
                    trae:Number(r.trae) || null,
                    // Капарото на ТОЗИ човек за ТАЗИ услуга. Дотук стоеше
                    // само в ПОКАПАРО и се четеше чак при избор, затова
                    // списъкът не можеше да каже кой взима капаро и кой не.
                    kaparo:капароНа(u, r.staff_id),
                    red:(r.red === 0 || r.red ? Number(r.red) : null) });
    });
  });


  // Първо София, най-долу Стара Загора. Христина е най-евтина и излизаше
  // първа, а човек, който търси часа си в София, отваряше страницата и
  // виждаше избран друг град. Вътре в града: най-евтиното и най-скорошното.
  // Мила стои първа, винаги. Антонио, 09.10.2026: „на нея няма да ѝ
  // хареса, винаги най-отгоре трябва да стои тя."
  //
  // Той сам отбеляза, че това се бие с другата цел — да пълним графика
  // на Грета и Христина, които имат часове утре, докато Мила е до
  // февруари. Решението е нейно и е записано тук, за да не се „оправя"
  // после по погрешка. Жената пак вижда и трите, с цените и първия
  // свободен ден, така че по-близкото и по-евтиното не се крие.
  // Редът идва от базата, `profiles.red`, и пътува с всеки ред от
  // /api/svobodni. Дотук стоеше като списък с имена ТУК, в сайта: всяка
  // промяна искаше качване на тема, а това е решение на салона, не на
  // програмиста. Антонио го обсъжда с Мила в петък.
  //
  // Списъкът с имена остава като резерва, за случая докато базата още не
  // носи числото: инак при празно `red` всички стават равни и подредбата
  // пада обратно на цената, тоест Христина пак излиза първа.
  var РЕД_НА_ХОРАТА = ['Мила Савова', 'Грета', 'Христина'];
  function тежест(р){
    if(р.red !== null && р.red !== undefined) return р.red;
    var i = РЕД_НА_ХОРАТА.indexOf(р.staff);
    return i < 0 ? РЕД_НА_ХОРАТА.length : i;
  }
  редове.sort(function(a,b){
    var пa = тежест(a), пb = тежест(b);
    if(пa !== пb) return пa - пb;
    var гa = /Стара/.test(a.grad) ? 1 : 0, гb = /Стара/.test(b.grad) ? 1 : 0;
    return гa - гb || a.cena - b.cena || (a.parvi < b.parvi ? -1 : 1);
  });

  // VIP часовете се отделят. Те са същата процедура, платена по-скъпо за
  // по-скоро. В общия списък вдигаха цената до 1 500 € и объркваха човек,
  // който още решава дали изобщо иска процедурата. Предлагат се отделно,
  // на този, който вече е видял кога е първият обикновен час.
  // За VIP се брои само ред, чийто етикет наистина го казва. Преди тук
  // стоеше „всяка услуга, различна от основната", което на страница за
  // цяло семейство значи ВСИЧКИ останали: при стриите „Не чакай дълго"
  // излизаше за двайсет и пет обикновени зони.
  function виПли(r){ return /vip|вип/i.test(r.etiket || ''); }
  // Ниво без нито един свободен час изчезваше напълно от страницата.
  // „VIP · до 1 седмица" за 1500 € не се виждаше никъде, защото двата
  // прозореца на Мила (вторник и четвъртък 16:00) бяха заети. Жената не
  // разбираше, че такава възможност изобщо съществува.
  //
  // Затова го показваме, но без да лъжем: пише, че в този срок няма, и
  // се предлага обаждане. Празният ред не се натиска.
  НИВА.forEach(function(н){
    if(!/vip|вип/i.test(н.etiket || '')) return;
    if(редове.some(function(r){ return r.usluga === н.usluga; })) return;
    if(ДОПУСТИМИ && ДОПУСТИМИ.indexOf(н.usluga) < 0) return;
    редове.push({ usluga:н.usluga, etiket:н.etiket, staff:null, staff_id:null,
                  cena:Number(н.cena)||0, parvi:null, grad:'', nyama:true });
  });

  ВИП = редове.filter(виПли);
  редове = редове.filter(function(r){ return !виПли(r); });
  if(!редове.length){ редове = ВИП; ВИП = []; }

  if(!редове.length){
    var празно = $('usl-hora');
    if(празно) празно.innerHTML = '<div class="usl-chaka">Няма свободни часове напред. ' +
      'Обади се на ' + телЛинк() + '.</div>';
    return [];
  }

  // Една цена, не обхват. „€450 – €1500" не казва нищо на жената: това
  // беше разстоянието от Христина в Стара Загора до VIP час другата
  // седмица. Показва се цената на самата процедура, а какво струва при
  // всеки отделен човек пише на неговия ред по-долу.
  var кц = $('usl-cena'), кл = $('usl-lenta-cena');
  var текст = ПЪЛНА > 0 ? евро(ПЪЛНА) : 'включен';
  if(кц) кц.textContent = текст;
  if(кл) кл.textContent = текст;

  // Дропдаун: свит показва само избраното, отворен дава всички възможности.
  // Така страницата не започва със стена от цени.
  var г = $('usl-hora');

  // Един човек не е избор.
  //
  // Антонио: „когато е само един човек за дадена процедура, няма смисъл да
  // го изписваме по този начин." Дотогава и при една възможност стоеше
  // бутон със стрелка, който се отваря и показва същия един ред. Сега е
  // просто ред текст: „Грета · София", и жената минава направо на датата.
  var самоЕдин = редове.length === 1 && !ВИП.length;
  if(г && самоЕдин){
    var р1 = редове[0];
    РЕДОВЕ = редове.concat(ВИП);
    избор.specialist = р1.staff;
    ИЗБРАНО = р1.usluga;
    ЦЕНИ = {}; редове.forEach(function(r){ ЦЕНИ[r.usluga + '|' + r.staff] = r.cena; });
    // Един човек, едно място: редът „При кого" не носи решение и само
    // отнема стъпка. Антонио, 09.10.2026: „ясно е, че е Грета, махни го."
    // Данните си остават — скрива се само от очите.
    // На продукта редът се СКРИВА: горе стои голямото число и целият
    // разказ за процедурата, а „един човек не е избор".
    //
    // На „Запази час" горе число НЯМА — цената живее точно тук. Скрием ли
    // реда и там, жената от рекламата остава пред чипове и календар, без
    // име, без град и без цена. Намерено на 24.10.2026 по връзката за
    // устни, където след избора остава един-единствен ред.
    var безЧислоГоре = !$('usl-cena');
    г.innerHTML =
      '<div class="usl-edin"' + (безЧислоГоре ? '' : ' hidden') + '>' +
        лицеТаг(р1.staff) +
        '<span class="usl-glava-etiket">При кого</span>' +
        '<b>' + (БЕЗ_ИМЕ ? 'Свободен час' : р1.staff) +
          (р1.grad ? '<em>' + р1.grad + времеНаРеда(р1) + '</em>' : '') +
          (безЧислоГоре ? '<i>' + ценаНаРеда(р1) + '</i>' : '') + '</b>' +
      '</div>' +
      '<div class="usl-grad" id="usl-grad" hidden></div>' +
      // Подканата стои, докато жената не е натиснала име, и изчезва в мига,
      // в който го направи. Антонио: „да напише избери при кой артист."
      // Без нея списъкът изглежда като справка, не като избор.
      (РЪЧНО_ИЗБРАН ? '' : '<div class="usl-podkana">Избери при кой артист</div>') +
      '<div class="usl-spisak" id="usl-spisak" hidden>' +
        '<button class="usl-chovek on" data-hora="' + р1.staff + '"' +
        ' data-usluga="' + р1.usluga + '"></button></div>';
    приложиЦена();
    return редове;
  }

  // Кой стои избран, когато страницата се отвори.
  //
  // Избраният човек се ПАЗИ при смяна на зоната. Преди тук сядаше винаги
  // първият ред, тоест жена, избрала Христина, при смяна на зона се
  // озоваваше при Грета в София, с друга цена. Човекът се сменя само ако
  // той не прави новата зона.
  //
  // Няма ли избран, сяда първият БЕЗ капаро. Антонио, 22.10.2026: „искам
  // по такъв начин да го представим, че първо излиза опцията без…
  // при Мила нещата се запазват да имат капаро, на другите не, понеже
  // при другите часовете са по-свободни." Жената отваря страницата и
  // горе пише „Без капаро" и цялата сума в деня на часа; натисне ли
  // „При кого" и избере Мила, тогава излизат €200 капаро.
  //
  // Редът в списъка НЕ се пипа: Мила си остава първа (CLAUDE.md, „Мила е
  // първа на сайта. Винаги."). Сменя се само кой е отметнат.
  var оставаЛи = избор.specialist &&
    редове.filter(function(r){ return r.staff === избор.specialist; })[0];
  var първоБез = редове.filter(function(r){
    return r.kaparo === 0 && r.cena > 0; })[0];
  var избран = оставаЛи || първоБез || редове[0];
  избор.specialist = избран.staff;
  ИЗБРАНО = избран.usluga;

  if(г){
    г.innerHTML =
      '<button class="usl-glava" id="usl-glava" type="button" aria-expanded="false">' +
        '<span class="usl-glava-tekst">' +
        // Етикетът „При кого и кога" е махнат на 30.10.2026. Антонио:
        // „само взима място." Под него и без това стои самият избор —
        // име, град и първи свободен ден — който казва същото с думи,
        // които значат нещо. На телефон този ред изблъскваше календара
        // надолу, а точно него жената търси.
        '' +
        '<span class="usl-glava-izbor" id="usl-glava-izbor"></span></span>' +
        '<span class="usl-glava-strelka" aria-hidden="true"></span></button>' +
      '<div class="usl-grad" id="usl-grad" hidden></div>' +
      // Подканата стои, докато жената не е натиснала име, и изчезва в мига,
      // в който го направи. Антонио: „да напише избери при кой артист."
      // Без нея списъкът изглежда като справка, не като избор.
      (РЪЧНО_ИЗБРАН ? '' : '<div class="usl-podkana">Избери при кой артист</div>') +
      '<div class="usl-spisak" id="usl-spisak" hidden>' +
      редове.map(function(r){
        // При някои процедури името на специалиста не се показва. Примерът
        // е премахването на стар перманентен грим: прави се от лекар и
        // името подвежда. Часът се запазва нормално, само надписът е друг.
        var кой = БЕЗ_ИМЕ ? (r.etiket && r.etiket !== 'обикновен час' ? r.etiket : 'Свободен час')
                          : r.staff;
        // ОТМЕТКАТА ИЗИСКВА ИСТИНСКО НАТИСКАНЕ.
        //
        // Антонио, 30.10.2026: „директно сяда върху Грета, само че тя не
        // е цъкната, тоест не е избрана. И не излиза следващият въпрос."
        //
        // Вътрешно пак има подразбиращ се човек — по него се смятат
        // цените в списъка и редът „без капаро" от 22.10, затова той НЕ
        // се маха. Маха се само лъжата на екрана: черната картичка с ✓
        // излиза едва когато жената наистина е натиснала име
        // (`РЪЧНО_ИЗБРАН`). Дотогава никой не изглежда избран и тя знае,
        // че ходът е неин.
        var тозиЛи = РЪЧНО_ИЗБРАН && r.staff === избран.staff;
        return '<button class="usl-chovek' + (тозиЛи ? ' on' : '') + '"' +
          ' data-hora="' + r.staff + '" data-usluga="' + r.usluga + '">' +
          лицеТаг(r.staff) +
          '<span><span class="kdo">' + кой + (r.etiket && r.etiket !== 'обикновен час' && !БЕЗ_ИМЕ
              ? ' <em>' + r.etiket + '</em>' : '') + '</span>' +
          '<span class="kade">' + (r.grad ? r.grad + ' · ' : '') +
          'първи свободен ' + датаБГ(r.parvi) + времеНаРеда(r) + '</span></span>' +
          '<span class="cena">' + ценаНаРеда(r) + капароНадпис(r) + '</span></button>' +
          // ВИП часовете стоят ПОД своя човек, не в отделен свит ред долу.
          // Антонио, 29.10.2026: когато избереш Мила, под нея така да ги
          // има тези, да не са в отделен таб долу. И двата ВИП часа са
          // закачени само за нея, значи мястото им е точно тук.
          (ВИП.some(function(v){ return v.staff === r.staff; }) ? покана(r.staff) : '');
      }).join('') + '</div>' + другиятСалон();
  }
  // Списъкът стои ОТВОРЕН, докато жената не избере сама.
  //
  // Дотук при кого беше падащо меню със стрелка и то започваше свито, за
  // да не почва страницата със „стена от цени". Цената на това свиване
  // се плащаше по телефона: имената на трите специалистки не се виждаха
  // никъде, преди жената да се сети да натисне стрелката. Три реда с
  // лица не са ценоразпис, а екип, затова стоят отворени.
  //
  // Свива се от само себе си в мига, в който тя натисне човек.
  if(!РЪЧНО_ИЗБРАН) отвориСписъка(true);
  // Въпросът за стария грим стои НАД списъка с хората.
  //
  // Кутията се ражда, преди този списък да е влязъл в страницата, и
  // тогава пада под него. Тук е мигът, в който хората вече ги има, затова
  // мястото се налага точно сега. Проверката пести местене, ако е там.
  try{
    var трк = $('rez-triazh'), грк = $('usl-hora');
    if(трк && грк && грк.parentNode){
      // Следата остава в страницата, за да се вижда, че този ред е минал:
      // Shopify минифицира JS-а и коментарите изчезват, тоест по тях не
      // може да се провери дали качената версия е новата.
      трк.setAttribute('data-nad-horata', '1');
      if(грк.previousElementSibling !== трк) грк.parentNode.insertBefore(трк, грк);
    }
  }catch(e){}
  РЕДОВЕ = редове.concat(ВИП);
  ЦЕНИ = {}; редове.forEach(function(r){ ЦЕНИ[r.usluga + '|' + r.staff] = r.cena; });
  приложиЦена();
  опишиИзбора();
  // Прерисуват ли се хората, редът „по-рано" също се преизчислява:
  // иначе остава от предишното състояние.
  try{
    var изб = (редове || []).filter(function(x){
      return x.usluga === ИЗБРАНО && x.staff === избор.specialist; })[0];
    if(изб) покажиПоРано(изб);
  }catch(e){}

  return редове;
}

// „Не чакай дълго." Един ред, не трети ценови етикет. Натисне ли го
// човекът, вижда какво струва да е по-скоро и при кого.
// Поканата се рисува веднъж заедно със списъка, а изборът се сменя после.
// Затова я показваме и скриваме отделно: инак при избрана Мила оставаше
// скрита, защото при първото рисуване още никой не е избран.
function опресниПоканата(){
  var е = document.querySelector('.usl-vip');
  if(!е) return;
  var обикн = (РЕДОВЕ || []).filter(function(r){ return !/vip|вип/i.test(r.etiket || ''); });
  е.hidden = !трябваЛиПокана(обикн);
}

// „Не чакай дълго" излиза само когато наистина се чака.
//
// Антонио, 08.10.2026: „ако избереш Грета или Христина, няма такъв ред,
// защото при тях реално не се чака." Вярно е и се вижда от самите данни:
// ВИП часовете са на Мила, чийто пръв свободен е февруари, а Грета и
// Христина имат утре. Да предлагаш 1500 € на жена, която може да дойде
// утре за 450, е обида.
//
// Затова правилото не е „кой е избран", а „по-рано ли е ВИП часът от
// този, който вече ѝ се предлага". Така не трябва да се пипа, ако утре
// някой друг получи ВИП прозорци.
function трябваЛиПокана(редове){
  if(!ВИП.length) return false;
  // Без избран човек поканата не се показва. При първо отваряне тя
  // излизаше и за Грета, чийто пръв свободен е утре, защото още никой
  // не беше избран и правилото гледаше всички ВИП редове.
  if(!избор.specialist) return false;
  // Сравнява се с ИЗБРАНИЯ човек, не с най-ранния изобщо. Първия път
  // гледах най-ранния ред на страницата и откакто Грета има час утре,
  // поканата изчезваше дори при избрана Мила, чийто пръв свободен е
  // февруари. Видяно от Антонио, 08.10.2026.
  var кой = избор.specialist;
  var негови = ВИП.filter(function(r){ return r.parvi && (!кой || r.staff === кой); });
  if(!негови.length) return false;
  var вип = негови.sort(function(a,b){ return a.parvi < b.parvi ? -1 : 1; })[0];
  var мой = (редове || []).filter(function(r){ return r.parvi && (!кой || r.staff === кой); })
               .sort(function(a,b){ return a.parvi < b.parvi ? -1 : 1; })[0];
  if(!мой) return true;
  return вип.parvi < мой.parvi;
}

// Един ред за другия салон, когато човекът е дошъл с избран град.
// Не го мести: само му казва, че там има по-скоро или по-евтино.
function другиятСалон(){
  if(!ДРУГИЯТ) return '';
  // ВНИМАНИЕ: в ПОНИВА стоят СУРОВИ часове от сървъра. Те имат `den`, а
  // `parvi` се появява чак в нарисувайХора, когато всеки човек се свие до
  // един ред. Дотук тук пишеше `r.parvi` — значи нито един ред не влизаше
  // в сметката, `тукНай` оставаше null и `поРано` ставаше ВИНАГИ вярно.
  //
  // Затова редът излизаше всеки път: на 24.10.2026 Христина имаше час на
  // 27 октомври, а отдолу пишеше „И в София · свободен час още 27
  // октомври" — същият ден, тоест предложение, което не предлага нищо.
  // Антонио: „не разбирам това отдолу какво имаш предвид с него."
  var тукНай = null;
  Object.keys(ПОНИВА).forEach(function(u){
    (ПОНИВА[u] || []).forEach(function(r){
      var кога = r.parvi || r.den;
      if(!кога) return;
      if(!тукНай || кога < тукНай.koga) тукНай = {koga: кога, cena: Number(r.cena) || 0};
    });
  });
  // Ако тук е също толкова рано и не е по-скъпо, няма какво да предлагаме.
  var поРано = !тукНай || ДРУГИЯТ.parvi < тукНай.koga;
  var поЕвтино = !!тукНай && тукНай.cena > 0 && Number(ДРУГИЯТ.cena) < тукНай.cena;
  if(!поРано && !поЕвтино) return '';
  var какво = [];
  if(поРано) какво.push('свободен час още ' + датаБГ(ДРУГИЯТ.parvi));
  if(поЕвтино) какво.push(ценаНаРеда(ДРУГИЯТ));
  // Връзката само МАХА града, нищо друго: нивото и отговорът за грима се
  // пазят. Първия път сложих тук nivo-то на другия салон и жената,
  // тръгнала за първична, се озоваваше на поддръжка.
  var адр;
  try{
    var у = new URLSearchParams(location.search);
    у.delete('grad');
    адр = location.pathname + (у.toString() ? '?' + у.toString() : '');
  }catch(e){ адр = location.pathname; }
  return '<a class="usl-drug-salon" href="' + адр + '">' +
    '<span><b>И в ' + ДРУГИЯТ.grad + '</b>' +
    '<em>' + какво.join(' \u00B7 ') + '</em></span><i>виж</i></a>';
}

// Поканата е за ЕДИН човек и стои отворена. Беше <details>, тоест
// трябваше да се цъкне. Жена, която гледа март при Мила, няма да цъкне
// нещо, което изглежда като странична бележка — а точно на нея 1000 €
// спестяват четири месеца чакане.
function покана(кой){
  var мои = ВИП.filter(function(r){ return !кой || r.staff === кой; });
  var сЧас = мои.filter(function(r){ return !r.nyama; });
  var най_скоро = сЧас.slice().sort(function(a,b){ return a.parvi < b.parvi ? -1 : 1; })[0];
  return '<div class="usl-vip usl-vip-otvoren">' +
    '<div class="usl-vip-glava"><b>Не чакай дълго</b>' +
    '<span>' + (най_скоро
        ? ('Свободен час още ' + датаБГ(най_скоро.parvi))
        : 'виж възможностите') + '</span></div>' +
    мои.map(function(r){
      if(r.nyama){
        return '<div class="usl-chovek usl-chovek-vip usl-chovek-nyama">' +
          '<span><span class="kdo">' + (r.etiket || '') + '</span>' +
          '<span class="kade">няма свободен в този срок \u00B7 ' +
          '<a href="tel:+359885041696">обади се</a></span></span>' +
          '<span class="cena">' + евро(r.cena) + '</span></div>';
      }
      return '<button class="usl-chovek usl-chovek-vip" type="button"' +
        ' data-hora="' + r.staff + '" data-usluga="' + r.usluga + '">' +
        '<span><span class="kdo">' + (БЕЗ_ИМЕ ? (r.etiket || 'Свободен час') : (r.etiket || r.staff)) + '</span>' +
        '<span class="kade">' + (r.grad ? r.grad + ' · ' : '') +
        'първи свободен ' + датаБГ(r.parvi) + времеНаРеда(r) + '</span></span>' +
        '<span class="cena">' + ценаНаРеда(r) + '</span></button>';
    }).join('') +
    '</div>';
}

// какво пише на свитата глава
function опишиИзбора(){
  var к = $('usl-glava-izbor');
  if(!к) return;
  var р = РЕДОВЕ.filter(function(x){
    return x.usluga === ИЗБРАНО && x.staff === избор.specialist; })[0];
  if(!р){ к.textContent = 'Избери'; return; }
  // При bez_ime името на специалиста не се показва НИКЪДЕ, не само под
  // календара: на премахването на стар грим горе пишеше „Грета · €100".
  // Мила не иска клиентката да избира човек за тези процедури.
  // Лицето стои и тук, не само в отворения списък. Свие ли се редът,
  // Мила пак се вижда: „да се вижда лицето на Мила, да пише Мила."
  к.innerHTML = лицеТаг(р.staff) + '<span class="usl-glava-red">' +
    '<b>' + (БЕЗ_ИМЕ
      ? (р.etiket && р.etiket !== 'обикновен час' ? р.etiket : 'Свободен час')
      : р.staff) + '</b>' +
    (р.etiket && р.etiket !== 'обикновен час' && !БЕЗ_ИМЕ ? ' <em>' + р.etiket + '</em>' : '') +
    // Цената тук също следва промо кода: иначе горе пише 382, а на този
    // ред 450, и жената не знае кое е вярното.
    ' · ' + ценаНаРеда(р) +
    '<small>' + (р.grad ? р.grad + ' · ' : '') + 'първи свободен ' + датаБГ(р.parvi) + времеНаРеда(р) + '</small>' +
    '</span>';
  предупредиЗаГрада(р);
  покажиПоРано(р);
}

// Един ред: „при Грета има още 3 ноември".
//
// Антонио, 22.10.2026: „ако на страницата на Мила видят, че може и при
// Грета по-скоро." И е точно така: по подразбиране стои Мила за 550 € с
// пръв свободен 4 март, а Грета е 450 € на 3 ноември и Христина 400 € на
// 27 октомври — но и двете седят в ЗАТВОРЕНО меню.
//
// Дотук единственото видимо предложение при дълго чакане беше „Не чакай
// дълго", което отваря VIP часовете за 1000 и 1500 €. Тоест отговорът на
// „чака се до март" беше „плати двойно".
//
// Мила остава първа по избор — това е нейно решение. Сменя се само дали
// по-близката възможност се вижда, или трябва да я откриеш.
var ДАЛЕЧ_ДНИ = 21;

// НАБЛЮДАТЕЛ. Редът се скрива сам, щом горе се появи същото име.
//
// Антонио го виждаше, аз — не. Защото е състезание: моята проверка го
// хваща скрит, а секунда по-късно друго прерисуване го връща. Вместо да
// гоня кое точно прерисуване е, тук се следи самият надпис горе. Смени
// ли се, редът се пита още веднъж — и ако вече рекламира избрания, си
// отива.
function пазиПоРано(){
  var горе = document.getElementById('usl-glava-izbor');
  if(!горе || горе.dataset.pazen) return;
  горе.dataset.pazen = '1';
  var провери = function(){
    var к = document.getElementById('usl-po-rano');
    if(!к || к.hidden) return;
    var за = к.dataset.za || '';
    if(за && (горе.textContent || '').indexOf(за) >= 0) к.hidden = true;
  };
  try{
    new MutationObserver(провери).observe(горе,
      {childList:true, subtree:true, characterData:true});
  }catch(e){}
  // Подсигуровка: ако наблюдателят не тръгне, пак се проверява при
  // натискане някъде в кутията.
  document.addEventListener('click', function(){ setTimeout(провери, 400); }, true);
}

function покажиПоРано(избраният){
  пазиПоРано();
  var кутия = document.getElementById('usl-po-rano');
  if(!кутия){
    var след = document.getElementById('usl-glava-izbor');
    if(!след || !след.parentNode) return;
    кутия = document.createElement('div');
    кутия.id = 'usl-po-rano';
    кутия.className = 'usl-po-rano';
    кутия.hidden = true;
    след.parentNode.insertBefore(кутия, след.nextSibling);
  }
  try{
    if(!избраният || !избраният.parvi){ кутия.hidden = true; return; }
    var дни = Math.round((new Date(избраният.parvi) - Date.now()) / 86400000);
    if(дни < ДАЛЕЧ_ДНИ){ кутия.hidden = true; return; }

    // Само обикновени редове: VIP не е по-рано, а по-скъпо.
    var кандидати = (РЕДОВЕ || []).filter(function(r){
      return r.usluga === ИЗБРАНО && !r.nyama && !/vip|вип/i.test(r.etiket || '') &&
             r.staff !== избраният.staff && r.parvi && r.parvi < избраният.parvi;
    });

    // САМО СЪЩИЯТ ГРАД. Антонио, 27.10.2026: „някой, който е влязъл и
    // гледа от София, него не го интересува, че има Стара Загора. По-скоро
    // да е между Мила и Грета, за да могат да отидат при Грета по-скоро."
    //
    // Дотук другият град оставаше като резерва, когато в нейния няма нищо
    // по-рано. Това не е услуга: предлага ѝ се път от 200 километра и
    // редът изглежда като оферта, а не като помощ. Няма ли по-скоро в
    // нейния град, не се предлага нищо.
    //
    // Няма ли град на избрания ред, не гадаем — редът си мълчи.
    if(!избраният.grad){ кутия.hidden = true; return; }
    var по_рано = кандидати
      .filter(function(r){ return r.grad === избраният.grad; })
      .sort(function(a, b){ return a.parvi < b.parvi ? -1 : 1; })[0];

    if(!по_рано){ кутия.hidden = true; return; }

    // ПОСЛЕДНА ПРОВЕРКА: никога не предлагай този, който вече е избран.
    //
    // Антонио, 22.10.2026, в инкогнито: натиска „вземи този", избира се
    // Грета — и редът продължава да предлага Грета. По моите стъпки не
    // се възпроизвежда, значи има път, по който `избраният` и
    // `избор.specialist` се разминават. Вместо да го гадая, тук се пита
    // и двете: съвпадне ли името с избраното, редът си отива.
    // Сравнява се и с НАПИСАНОТО ГОРЕ, не само с вътрешното състояние.
    //
    // Антонио го възпроизведе три пъти: избрана е Грета, а редът пак
    // предлага Грета. Проверих — пазачките по `избор.specialist` и по
    // `избраният.staff` бяха качени и пак не хващаха, тоест в този път
    // двете се разминават с това, което човекът вижда.
    //
    // Затова последната дума я има екранът: пише ли вече това име горе,
    // редът няма работа тук. Не е елегантно, но не може да сгреши.
    var горе = document.getElementById('usl-glava-izbor');
    var текстГоре = горе ? горе.textContent : '';

    if(по_рано.staff === избор.specialist ||
       по_рано.staff === избраният.staff ||
       (по_рано.staff && текстГоре.indexOf(по_рано.staff) >= 0) ||
       !(по_рано.parvi < избраният.parvi)){
      кутия.hidden = true; return;
    }

    кутия.hidden = false;
    // Кого рекламира в момента. Пази се на самия елемент, за да може
    // наблюдателят отдолу да се самопровери по всяко време.
    кутия.dataset.za = по_рано.staff || '';
    кутия.innerHTML = '<span>При <b>' + по_рано.staff + '</b> има час още ' +
      датаБГ(по_рано.parvi) + (по_рано.grad ? ' · ' + по_рано.grad : '') +
      ' · ' + евро(по_рано.cena) + '</span>' +
      '<button type="button" class="usl-po-rano-vzemi" data-hora="' +
        String(по_рано.staff).replace(/"/g, '&quot;') + '" data-usluga="' +
        String(по_рано.usluga).replace(/"/g, '&quot;') + '">вземи този</button>';
  }catch(e){ кутия.hidden = true; }
}

// Христина е в Стара Загора и е най-евтината. Човек цъка нейния ред
// точно заради цената, дребният ред с града не се чете, и разбира чак
// когато някой му се обади. Затова изборът на друг град се казва на
// глас, с цвят, а не с дребен шрифт.
// Къде е часът. Беше „Внимание: този час е в Стара Загора, НЕ в София",
// което имаше смисъл, когато градът идваше незабелязано от най-евтиния
// ред. Сега градът пише под името на специалистката и жената я избира
// съзнателно, затова предупреждението звучеше като съобщение за грешка.
// Остава адресът, който ѝ трябва, без „внимание" и без „не в София".
var АДРЕСИ = {
  'София': 'Манастирски ливади, ул. Акад. Илчо Димитров 7',
  'Стара Загора': 'ул. Хаджи Димитър Асенов 87'
};
function предупредиЗаГрада(р){
  var г = $('usl-grad');
  if(!г) return;
  var град = р && р.grad;
  г.hidden = !град;
  if(!град) return;
  // Антонио: „салон адреса му го махни отдолу." Градът пише под името на
  // специалистката, значи редът долу повтаряше вече казаното. Адресът е на
  // „Контакти" и в потвърждението по имейл, където наистина трябва.
  г.hidden = true;
  г.innerHTML = '';
}

function отвориСписъка(да){
  var гл = $('usl-glava'), сп = $('usl-spisak');
  if(!гл || !сп) return;
  // Списъкът вече НЕ се свива. Мила, 29.10.2026: избереш ли човек, той
  // се свиваше в един ред и за да се върнеш на друг, трябваше пак да
  // цъкнеш свитото. Антонио: другите двама отдолу пак да са отворени.
  // Виканията с false остават по местата си, но не свиват нищо.
  var отворен = true;
  сп.hidden = !отворен;
  гл.setAttribute('aria-expanded', String(отворен));
  гл.classList.toggle('otvoren', отворен);
}

// Колко трае процедурата ПРИ ТОЗИ ЧОВЕК. Числото идва от базата
// (`service_staff.minuti`) и пътува с всеки свободен час. Връща null,
// когато го няма — тогава остава времето на услугата.
//
// Всичко е в try, защото на 16.10.2026 моя предишна версия на това
// счупи страницата на живо: работеше при мен, защото браузърът ми
// държеше стария файл, а в инкогнито падаше. Тази функция не бива да
// може да убие резервацията заради един надпис.
function времеЗа(услуга, човек){
  try{
    var р = РЕДОВЕ.filter(function(x){
      return x.usluga === услуга && x.staff === човек; })[0];
    return (р && р.trae) ? Number(р.trae) : null;
  }catch(e){ return null; }
}

// Времето в реда на човека, след наклонена черта. Мила, 4.11.2026: редът над
// бутона не върши работа, защото след избора на човек жената не го вижда.
// r.trae е времето ПРИ ТОЗИ ЧОВЕК. При зоните часът е сборът им.
function времеНаРеда(r){
  try{
    var м = ПО_ЗОНИ ? ТРАЕНЕ : (r.trae || ТРАЕНЕ_НА[r.usluga] || 0);
    return (м && Number(м) > 0) ? ' / ' + времеТекст(Number(м)) : '';
  }catch(e){ return ''; }
}
function времеТекст(м){
  return м >= 60 ? (Math.floor(м/60) + ' ч' + (м%60 ? ' ' + (м%60) + ' мин' : '')) : (м + ' мин');
}
// Страница без избор на човек: една дата и времето. Има ли варианти с различно
// време (микронидлинг 60 до 90), показва обхвата, не едно от числата.
function времеОтВсички(){
  try{
    var в = [];
    Object.keys(ПОНИВА || {}).forEach(function(к){
      (ПОНИВА[к] || []).forEach(function(r){ var м = Number(r.trae); if(м > 0) в.push(м); });
    });
    if(!в.length) return '';
    var от = Math.min.apply(null, в), до = Math.max.apply(null, в);
    return ' / ' + (от === до ? времеТекст(от) : времеТекст(от) + ' до ' + времеТекст(до));
  }catch(e){ return ''; }
}

function покажиТраене(минути){
  try{
    if(!минути || isNaN(минути) || Number(минути) <= 0) return;
    ТРАЕНЕ = Number(минути);
    var т = document.getElementById('usl-traene');
    if(!т) return;
    т.hidden = false;
    т.textContent = (ТРАЕНЕ >= 60)
      ? (Math.floor(ТРАЕНЕ/60) + ' ч' + (ТРАЕНЕ%60 ? ' ' + (ТРАЕНЕ%60) + ' мин' : ''))
      : (ТРАЕНЕ + ' минути');
  }catch(e){}
}

// ------------------------------------------------------------------ промо код
//
// Антонио, 21.10.2026: „да си плащат същото капаро, просто крайната
// сума да е по-малка."
//
// Защо НЕ през Shopify. В касата влиза само капарото — един ред от
// „Запазване на час" за 100 €. Пълната цена на процедурата я няма там,
// тя живее тук. Значи процент в Shopify е процент от стоте евро, не от
// четиристотин и петдесетте.
//
// Тук сметката е наша, затова намалената цена тръгва с поръчката през
// `_pylna` и оттам влиза в картона при Ади, в календара и в
// напомнянето два дни преди часа. Капарото НЕ се пипа.
var КОДОВЕ = {
  // Мила, 22.10.2026, през Ади: „иска само срокът да се коригира да е
  // до края на годината." Беше до 25 октомври.
  //
  // `bez` дойде от една дупка, намерена на 23.10.2026: „Лазерна епилация ·
  // горна устна" също съдържа „устн", значи кодът за устните ѝ сваляше
  // цената. Дребни пари, но не е това, което Мила е обещала в писмото.
  USTNI15: {procent: 15, do: '2026-12-31', samo: /устн/i,
            bez: /лазер|епилац|курс/i},

  // Видеото за Стара Загора, 23.10.2026. Мила и Христина го казват на
  // глас: „−10% за Стара Загора, микропигментация и микроблейдинг, до
  // края на годината."
  //
  // Кодът е вързан за ГРАДА, не за човека. Днес Стара Загора е Христина,
  // но салонът е салон: поеме ли го друг, отстъпката пак е вярна, а в
  // София не хваща — дори жената да е дошла точно с връзката от
  // рекламата и после да е натиснала „И в София".
  SZ10: {procent: 10, do: '2026-12-31',
         samo: /устн|микроблейдинг/i,
         // Видеото казва две процедури. „Лазерна епилация · горна устна"
         // и „Поддръжка на микроблейдинг" носят същите думи в името, но
         // не са те.
         bez: /лазер|епилац|курс|поддръжка/i,
         grad: /стара\s*загора/i,
         red: '\u221210% до 31.12, само в Стара Загора'},

  // Връщане след недовършено записване. Антонио, 27.10.2026: „на хората,
  // които остават някакви запазени часове, да им се пращат имейли… 5% от
  // дадената процедура."
  //
  // Кодът живее САМО във връзката на писмото за изоставена каса. Жената
  // не го пише: цъка бутона и цената вече е намалена.
  //
  // Важи за всяка процедура, защото писмото я догонва с това, което ТЯ е
  // започнала. Курсовете отпадат: там пет на сто са сто и петдесет евро
  // и това не е дребна отстъпка, а решение на Мила.
  //
  // Закръгля се до ЦЯЛО ЕВРО, не до десетица както другите два. При пет
  // на сто десетицата лъже в наша вреда: 450 € щеше да стане 420, тоест
  // почти седем на сто. До цяло евро 450 става 427.
  // БЕЗ срок. Антонио, 27.10.2026: „не им даваме 5%, защото се връщат до
  // 31 декември, а им даваме 5%, когато се върнат и си вземат часа, когато
  // и да било." Срокът тук не печели нищо: писмото не е кампания, а второ
  // подаване на ръка към жена, която вече е била решила.
  VARNISE5: {procent: 5,
             samo_zapazenata: true,
             bez: /курс/i,
             zaokrygli: 'evro',
             red: '\u22125%, защото се върна'}
};
var ПРОМО = null;            // {kod, procent}, смята се при всяко прилагане
// БЕЗ стойност тук. Този ред стои ПОД началното нагласяване, където
// кодът вече е прочетен от адреса, и „= ''" го зануляваше обратно.
// Декларацията се вдига нагоре, присвояването — не.
var ПРОМО_КОД;               // каквото е дошло в адреса
var ЦЕНА_БЕЗ_ПРОМО = 0;
// За коя услуга е даден кодът. Празно значи „за всичко, което кодът
// позволява" — така работят кампанийните кодове (SZ10, USTNI15).
//
// БЕЗ стойност тук, както при ПРОМО_КОД: този ред стои ПОД началното
// нагласяване, където `кодътОтАдреса()` вече е попълнил услугата, и
// „= ''" я зануляваше обратно. Декларацията се вдига нагоре,
// присвояването — не.
var ПРОМО_УСЛУГА;

// `град` е градът на РЕДА, който е избран в момента. Подава се отвън,
// защото приложиЦена вече го е намерила; липсва ли, пита списъка.
function промоВали(текст, град){
  var к = String(текст || '').trim().toUpperCase();
  var д = КОДОВЕ[к];
  if(!д) return null;
  // Срокът свършва в края на последния ден, по СОФИЙСКАТА ДАТА.
  //
  // Беше записан с час и лятно време: `T23:59:59+03:00`. Само че на
  // 25.10.2026 в 4 сутринта България минава на зимно и +03:00 става
  // +02:00 — кодът щеше да умре в 22:59 вместо в 23:59, точно в
  // последната вечер на промоцията.
  //
  // Сравнението по дата не зависи от смяната на часа.
  if(д.do){
    var днес;
    try{
      днес = new Intl.DateTimeFormat('en-CA', {timeZone:'Europe/Sofia',
        year:'numeric', month:'2-digit', day:'2-digit'}).format(new Date());
    }catch(e){ днес = new Date().toISOString().slice(0,10); }
    if(днес > д.do) return null;
  }
  // Кодът важи само за своята процедура, за да не слиза цената на
  // микроблейдинга, защото някой е препратил писмото.
  var какво = String(ИМЕ || '') + ' ' + String(ИЗБРАНО || '');
  if(д.samo && !д.samo.test(какво)) return null;
  if(д.bez && д.bez.test(какво)) return null;
  // Код на един салон важи само в неговия град.
  //
  // Градът се чете от реда на специалистката, не от `?grad=` в адреса:
  // адресът само пресява списъка, а жената може да го смени с едно
  // натискане на „И в София". Тогава цената трябва да се върне.
  //
  // Не знаем ли града, отстъпката НЕ се дава. По-добре жената да види
  // пълната цена и да ѝ я намалим, отколкото обратното.
  if(д.grad){
    var г = град || градътНаИзбора();
    if(!г || !д.grad.test(String(г))) return null;
  }
  // Кодът от писмото важи САМО за процедурата, която жената е изоставила.
  //
  // Антонио, 27.10.2026, със снимка на микроблейдинга: „какви са тези
  // отстъпки тук, откъдето и да влезнат защо има отстъпки фиксирани…
  // отстъпките са 5% и то когато се връщат, а не като влезе нов човек."
  // Дотук кодът се пазеше 30 дни и сваляше цената на ВСЯКА процедура,
  // включително такива, които тя изобщо не е гледала. Пет на сто от 550
  // са 28 евро, подарени без причина.
  //
  // Кампанийните кодове (SZ10, USTNI15) нямат това ограничение: те са
  // обявени публично и важат за каквото пише в тях.
  if(д.samo_zapazenata){
    if(!ПРОМО_УСЛУГА) return null;
    var сега_услуга = ИЗБРАНО || УСЛУГА || '';
    if(сега_услуга !== ПРОМО_УСЛУГА) return null;
  }
  return {kod: к, procent: д.procent, red: д.red || '', zaokrygli: д.zaokrygli || ''};
}

// Колко остава от цената при този процент. Една сметка, на едно място:
// ползва се и за избрания ред, и за всеки ред в списъка.
function намалена(цена, процент, как){
  // До цяло евро, когато кодът го иска. Виж бележката при VARNISE5:
  // при малък процент десетицата дава повече отстъпка от обещаната.
  if(как === 'evro') return Math.floor(цена * (100 - процент) / 100);
  return Math.floor(цена * (100 - процент) / 1000) * 10;
}

// Цената на ЕДИН ред от списъка, с неговата си отстъпка.
//
// Антонио, 23.10.2026, със снимка на екрана: „тук, като видя Христина
// отдолу, още тук да ѝ пише отстъпката, а не чак като я избера."
//
// Всеки ред се пита поотделно, защото кодът може да важи само за своя
// град. В един и същ списък Грета в София стои с пълна цена, а Христина
// в Стара Загора — с намалена. Жената вижда разликата, преди да избере.
function ценаНаРеда(r){
  var цена = Number(r && r.cena) || 0;
  if(!(цена > 0)) return евро(цена);
  var п = промоВали(ПРОМО_КОД, r.grad);
  if(!п) return евро(цена);
  var нова = намалена(цена, п.procent, п.zaokrygli);
  if(!(нова > 0) || нова >= цена) return евро(цена);
  return '<s>' + евро(цена) + '</s> ' + евро(нова);
}

// Същите думи и на страницата „Запази час".
//
// Там голямото число и редът под него ги няма — цената живее вътре в
// „При кого и кога". Значи зачертаното се вижда, а ЗАЩО е зачертано —
// не. Затова промоцията се казва в кутията „Запазваш часа без капаро",
// която стои най-отгоре и без това се чете.
//
// Рекламата за Стара Загора води точно тук, а Антонио иска думите да
// излизат преди жената да е натиснала каквото и да било.
// Кутията „Запазваш часа без капаро" я няма винаги: текстът ѝ е
// настройка и на 25.10.2026 Антонио я изпразни. Промоцията обаче трябва
// да се казва и тогава — рекламата за Стара Загора води точно тук и
// жената трябва да види ЗАЩО цената е зачертана, преди да натисне нещо.
// Затова, ако кутията я няма, си правим своя на същото място.
function кутиятаЗаПромо(){
  if(!document.querySelector) return null;
  var к = document.querySelector('.zap-bez');
  if(к) return к;
  if(!(ПРОМО && ПРОМО.red)) return null;      // няма промоция, няма кутия
  var след = document.querySelector('.zap-ocenka');
  var преди = document.querySelector('.zap-vodach');
  var дом = (след && след.parentNode) || (преди && преди.parentNode);
  if(!дом) return null;
  к = document.createElement('div');
  к.className = 'zap-bez zap-bez-samo-promo';
  if(след && след.nextSibling) дом.insertBefore(к, след.nextSibling);
  else if(преди) дом.insertBefore(к, преди);
  else дом.appendChild(к);
  return к;
}

function промоВКутията(){
  // Редът излиза САМО когато има от какво да се вади.
  //
  // Антонио, 27.10.2026, на „Запази час" преди да е избрал каквото и да
  // е: „−5% защото се върна" виси само̀ над списъка с групи процедури и
  // обещава отстъпка от нищо. Кодът се пази 30 дни, затова го виждаше и
  // при най-обикновено отваряне на страницата.
  //
  // Условието е ИСТИНСКА намалена цена: има избрана услуга и пълната ѝ
  // цена е паднала. Няма ли избор, няма и ред.
  var имаНамаление = !!(ПРОМО && ЦЕНА_БЕЗ_ПРОМО > 0 && ПЪЛНА > 0 &&
                        ЦЕНА_БЕЗ_ПРОМО > ПЪЛНА);
  var к = кутиятаЗаПромо();
  if(!к){
    // Кутията я няма (или не бива да се прави): махаме стар ред, ако е останал.
    var стар = document.querySelector('.zap-bez-samo-promo');
    if(стар && !имаНамаление && стар.parentNode) стар.parentNode.removeChild(стар);
    return;
  }
  var ред = к.querySelector('.usl-promo');
  if(!имаНамаление){
    if(ред && ред.parentNode) ред.parentNode.removeChild(ред);
    // Кутията, направена само заради промоцията, си отива с нея.
    if(к.classList.contains('zap-bez-samo-promo') && к.parentNode) к.parentNode.removeChild(к);
    return;
  }
  var текст = (ПРОМО && ПРОМО.red) ? ПРОМО.red : '';
  if(!текст){ if(ред && ред.parentNode) ред.parentNode.removeChild(ред); return; }
  if(!ред){
    ред = document.createElement('em');
    ред.className = 'usl-promo';
    к.appendChild(ред);
  }
  ред.textContent = текст;
}

function сПромо(цена){
  if(!ПРОМО || !(цена > 0)) return цена;
  // Надолу до цели ДЕСЕТ евро. Иначе 450 става 382,50, а цените навсякъде
  // се изписват в цели числа и горе излизаше 383 — с половин евро повече
  // от това, което тръгва с поръчката.
  //
  // Антонио, 23.10.2026: „цената пак не е ли малко по-добре, 380 евро."
  // Закръглянето до десетица дава 450 → 380 и 400 → 340: кръгли числа,
  // които се помнят и се казват на глас. Надолу, не нагоре: жената
  // плаща по-малко, а не повече от написаното.
  return намалена(цена, ПРОМО.procent, ПРОМО.zaokrygli);
}

// Кодът идва от АДРЕСА, не се пише на ръка.
//
// Антонио, 21.10.2026: „не искам да имат допълнителна стъпка и да
// трябва да пишат код." Затова бутонът в писмото води на
// /products/ustni-mikropigmentaciya?promo=USTNI15 и цената е намалена
// още с отварянето — жената вижда 382 вместо 450, без да прави нищо.
//
// Пази се за сесията: ако тръгне да разглежда и се върне, отстъпката
// не изчезва.
// Пази се 30 дни, в localStorage, както източникът на посещението.
//
// Дотук стоеше в sessionStorage, тоест живееше колкото ТАБА. Жена, която
// цъка рекламата, помисли и се върне на другия ден, плащаше пълна цена,
// без да разбере защо. Намерено на 26.10.2026 по тестовата поръчка #1095:
// Shopify ѝ беше записал адрес с promo=SZ10, а поръчката излезе без код,
// защото записването стана в друг таб.
//
// За писмото „не довърши запазването" това е решаващо: то догонва жената
// часове по-късно, в нов таб, често на друго устройство.
function кодътОтАдреса(){
  var ключ = 'mila_promo', сега = Date.now(), ДНИ30 = 30*24*3600*1000;
  var к = '';
  try{ к = new URLSearchParams(location.search).get('promo') || ''; }catch(e){}
  try{
    if(к){
      // Пази се и ЗА КОЯ услуга е даден. Писмото винаги носи `nivo`.
      var за = '';
      try{ за = new URLSearchParams(location.search).get('nivo') || ''; }catch(e){}
      localStorage.setItem(ключ, JSON.stringify({kod:к, kogato:сега, usluga:за}));
      ПРОМО_УСЛУГА = за;
      return к;
    }
    var сурово = localStorage.getItem(ключ);
    if(!сурово) return '';
    var з;
    // Старият запис беше гол низ, не обект: пази се, за да не изгубим
    // кодовете на хората, тръгнали преди тази промяна. Гол низ изобщо не
    // е JSON и `JSON.parse` гърми — затова се хваща и тук, не само когато
    // се разчете като низ.
    try{ з = JSON.parse(сурово); }catch(e){ return сурово; }
    if(typeof з === 'string') return з;
    if(!з || !з.kod) return '';
    if(з.kogato && (сега - з.kogato) > ДНИ30){ localStorage.removeItem(ключ); return ''; }
    ПРОМО_УСЛУГА = з.usluga || '';
    return з.kod;
  }catch(e){ return к; }
}

// Няма ли капаро, редът отдолу няма какво да каже: горе вече стои
// цялата цена. Освен ако има отстъпка — тогава показваме старата.
function kрСкрий(кр, стараЦена, сОтстъпка){
  if(сОтстъпка){ кр.hidden = false; кр.innerHTML = 'вместо <s>' + стараЦена + '</s>'; }
  else { кр.hidden = true; кр.textContent = ''; }
}

function приложиЦена(){
  // Цената и капарото идват от избрания ред: той знае и името, и staff_id.
  // Базата дава капарото по staff_id, затова търсим оттам, а не по име.
  var р = РЕДОВЕ.filter(function(x){
    return x.usluga === ИЗБРАНО && x.staff === избор.specialist; })[0];
  // При избрани зони цената и капарото са сборът и не се пипат: иначе
  // носителят си налага своите. Жена, избрала зони за 52 €, плащаше
  // капаро 35 €, защото часът минава през „цели крака" за 154 €.
  // Докато на лазера няма избрани зони, цената на носещата услуга НЕ се
  // налага: тя е 256 € за цяло тяло, а най-евтината зона е 13. Горе
  // стоеше 256 и изглеждаше, че нещо вече е избрано.
  var безИзбор = document.body.classList.contains('laz-bez-izbor');
  if(ЦЕНА_ОТ_ЧИПА != null && !р){
    // Цената от чипа е само докато списъкът още не знае за тази услуга.
    // Има ли ред, той командва: той знае цената НА ТОЗИ ЧОВЕК.
    //
    // Първо го написах да побеждава винаги и счупих точно това: на
    // микроблейдинга жената избираше Христина за 400 €, а долу стоеше
    // 550 — цената на Мила, дошла от чипа. Христина го видя и писа.
    // 10.10.2026.
    ПЪЛНА = ЦЕНА_ОТ_ЧИПА;
  } else if(!ПО_ЗОНИ && !безИзбор){
    if(р){
      if(р.cena) ПЪЛНА = р.cena;
      var кап = ПОКАПАРО[ИЗБРАНО + '|' + р.staff_id];
      if(кап != null && !isNaN(кап)) КАПАРО = кап;
    } else {
      var к = ЦЕНИ[ИЗБРАНО + '|' + избор.specialist];
      if(к) ПЪЛНА = к;
    }
  }
  // Промо кодът се прилага ПОСЛЕДЕН, върху вече установената цена:
  // дотук тя се мени от чипа, от реда на специалистката и от зоните.
  //
  // Проверява се всеки път, а не веднъж: кодът важи само за устните, а
  // коя е услугата се знае чак след като жената избере ниво.
  ПРОМО = промоВали(ПРОМО_КОД, р && р.grad);
  ЦЕНА_БЕЗ_ПРОМО = ПЪЛНА;
  ПЪЛНА = сПромо(ПЪЛНА);

  // Зоните: капарото следва сбора (след промо кода) и избрания човек.
  if(ПО_ЗОНИ) КАПАРО = капароЗаЗоните();
  // капарото не може да е по-голямо от цената
  ОСТАТЪК = Math.max(0, ПЪЛНА - Math.min(КАПАРО, ПЪЛНА));

  // Цената горе следва избора. Избере ли се VIP час, горе пише неговата
  // цена, не тази на обикновения: иначе на един екран стоят две числа
  // за едно и също нещо.
  var т = ПЪЛНА > 0 ? евро(ПЪЛНА) : 'включен';
  var сОтстъпка = ПРОМО && ЦЕНА_БЕЗ_ПРОМО > ПЪЛНА;

  // Горе е КАПАРОТО, не цялата цена.
  //
  // Антонио, 22.10.2026: „да пише капаро, останалите в деня на часа —
  // за да не ги отказваме, понеже сумата е най-малка."
  //
  // Цялата цена не се крие: слиза на реда отдолу. Няма ли капаро
  // (ретуш, маникюр), горе си остава цената, иначе редът е празен.
  // Навсякъде, където има капаро. Антонио, 22.10.2026: „ламинирането е
  // 45, капарото 10 — да пише 10 капаро, останалите в деня. Това трябва
  // да го приложим навсякъде, където има капаро, защото реално е така."
  //
  // Прагът от 150 €, който сложих преди това, беше грешка: маникюрът
  // изглеждаше странно не заради сумата, а защото при него капаро НЯМА
  // и €15 е най-ниската цена, не капаро.
  var имаКапаро = КАПАРО > 0 && ПЪЛНА > КАПАРО;
  // Мила, 22.10.2026, през Антонио: капаро остава САМО при нея. При Грета
  // и Христина се плаща всичко в салона. Тогава водещото не е цена, а
  // облекчение: „Без капаро". Цялата сума слиза на реда отдолу, за да не
  // изглежда, че процедурата е безплатна.
  var безКапаро = КАПАРО === 0 && ПЪЛНА > 0;
  var водещо = имаКапаро ? евро(КАПАРО) : (безКапаро ? 'Без капаро' : т);

  var кц = $('usl-cena'), кл = $('usl-lenta-cena');
  if(кц){
    // Отстъпката се показва там, където е цялата цена — при капарото
    // тя не личи, защото капарото не се мени от кода.
    кц.textContent = водещо;
  }
  if(кл) кл.textContent = т;

  var кр = $('usl-kaparo-red');
  if(кр){
    if(имаКапаро){
      кр.hidden = false;
      кр.innerHTML = 'капаро · останалите ' +
        (сОтстъпка ? '<s>' + евро(ЦЕНА_БЕЗ_ПРОМО - КАПАРО) + '</s> ' : '') +
        евро(ОСТАТЪК) + ' в деня на часа';
    } else if(безКапаро){
      кр.hidden = false;
      кр.innerHTML = (сОтстъпка ? '<s>' + евро(ЦЕНА_БЕЗ_ПРОМО) + '</s> ' : '') +
        евро(ПЪЛНА) + ' в деня на процедурата';
    } else {
      kрСкрий(кр, евро(ЦЕНА_БЕЗ_ПРОМО), сОтстъпка);
    }
    // Думите на промоцията, когато кодът носи такива.
    //
    // Жената идва от видео, в което Мила казва „−10% за Стара Загора до
    // края на годината". Ако на страницата стои само зачертано число, тя
    // не знае дали това е същото, или просто така си е. Затова същите
    // думи се повтарят под цената. Вътре в реда, не на нов абзац:
    // отделен ред отдолу лягаше върху текста за капарото.
    if(сОтстъпка && ПРОМО && ПРОМО.red && !кр.hidden){
      кр.innerHTML += '<em class="usl-promo">' + ПРОМО.red + '</em>';
    }
  }
  промоВКутията();

  // Капарото в лентата и в блока „Плащане" също следва избора. На страница
  // за цяло семейство чиповете сменят услугата, а тези числа оставаха с
  // началните: на пакет за 491 € пишеше капаро 20 €, тоест лъжеше.
  var кк = $('usl-lenta-kaparo');
  if(кк){
    // Нула капаро значи „плаща се на място": редът изчезва, вместо да
    // пише „капаро €0". Маникюрът остана така на 12.10.2026.
    if(КАПАРО > 0){ кк.hidden = false; кк.textContent = 'капаро ' + евро(КАПАРО); }
    else { кк.hidden = true; кк.textContent = ''; }
  }
  // Бележката под бутона на „Запази час". Два текста идват от секцията,
  // тук се избира кой е верен за ТОЗИ ред. Дотук стоеше един, „Капарото
  // заключва часа", и от 22.10.2026 лъжеше при всички освен Мила.
  var зб = $('zap-belezhka');
  if(зб){
    var тб = КАПАРО > 0 ? зб.dataset.sKaparo : зб.dataset.bezKaparo;
    // Празна настройка значи „не казвай нищо", а не празен ред.
    зб.textContent = тб || '';
    зб.hidden = !тб;
  }

  var пт = $('usl-plashtane-tekst');
  if(пт && пт.dataset.kaparoShablon){
    var к1 = пт.dataset.kaparoShablon.split('@@').join(String(Math.round(КАПАРО)));
    var к2 = пт.dataset.ostatakShablon
      ? пт.dataset.ostatakShablon.split('@@').join(String(Math.round(ОСТАТЪК))) : '';
    пт.innerHTML = ОСТАТЪК > 0 ? (к1 + ' ' + к2) : к1;
  }

  // Времето следва същия избор, от който идва цената. Иначе на екрана
  // стоят €450 (при Грета) и „1 ч" (времето на услугата) — две числа за
  // един и същ час, едното лъже. Ади го забеляза на 16.10.2026.
  //
  // Тук, в края, а не вътре в клоновете горе: цената идва ту от реда с
  // часовете, ту от чипа със специалистката, и само единият път минава
  // през реда. При зоните не се пипа, там сборът командва.
  if(!ПО_ЗОНИ) покажиТраене(времеЗа(ИЗБРАНО, избор.specialist));
}

// Колко напред трябва да е часът, за да го предлагаме. Жена, която чете
// сайта в 18:44, не може да дойде в 18:45.
//
// 120, не 60, за да съвпада с базата: функцията svobodni_chasove също не
// дава час по-рано от два часа. При 60 страницата, останала отворена, щеше
// да предлага час на час и половина напред, който базата после отказва при
// заделянето. Сменя се ли едното, сменя се и другото.
var ПРЕДИЗВЕСТИЕ = 120;

// Сегашният миг, както го вижда салонът, а не браузърът на клиентката.
// Телефонът ѝ може да е на друга часова зона, а салонът е в София.
function сегаВСофия(){
  var ф = new Intl.DateTimeFormat('en-CA', {timeZone:'Europe/Sofia',
    year:'numeric', month:'2-digit', day:'2-digit',
    hour:'2-digit', minute:'2-digit', hour12:false});
  var ч = {}; ф.formatToParts(new Date()).forEach(function(p){ ч[p.type] = p.value; });
  var часът = (+ч.hour) % 24;   // в полунощ някои браузъри връщат 24
  return { den: ч.year + '-' + ч.month + '-' + ч.day,
           minuti: часът * 60 + (+ч.minute) };
}

// Минал ли е вече този час. Базата филтрира по UTC и през лятото пропускаше
// по три часа назад: в 18:44 софийско предлагаше 17:45 за същия ден.
function вБъдещето(r){
  var сега = сегаВСофия();
  if(r.den > сега.den) return true;
  if(r.den < сега.den) return false;
  var ч = String(r.nachalo).split(':');
  var вминути = (+ч[0]) * 60 + (+(ч[1] || 0));
  return вминути >= сега.minuti + ПРЕДИЗВЕСТИЕ;
}

// Когато имената са скрити („Свободен час"), жената не е избрала човек —
// избрала е студио. Тогава дните и часовете са на ЦЕЛИЯ екип в този град,
// а кой ще я поеме се решава от самия час.
//
// Дотогава лентата показваше дните само на първия ред. На премахването
// това беше Мила с два свободни дни през октомври, докато Грета имаше
// осем. Ади го видя на 09.10.2026: „най-отгоре излизат само две опции,
// а на втория ред излизат всички."
function безИмена(){
  return БЕЗ_ИМЕ && !РЪЧНО_ИЗБРАН;
}
function градътНаИзбора(){
  var р = (РЕДОВЕ || []).filter(function(x){ return x.staff === избор.specialist; })[0];
  return (р && р.grad) || null;
}
function заДеня(d){
  var списък = (ПОНИВА[ИЗБРАНО] || []).filter(function(r){ return r.den === d && вБъдещето(r); });
  if(безИмена()){
    var гр = градътНаИзбора();
    return гр ? списък.filter(function(r){ return !r.grad || r.grad === гр; }) : списък;
  }
  if(избор.specialist) списък = списък.filter(function(r){ return r.staff === избор.specialist; });
  return списък;
}

// кои месеци изобщо имат нещо при този специалист
function месециСъсСвободно(){
  var м = [];
  редДни = [];
  // Само дните на ИЗБРАНИЯ специалист. Иначе лентата показваше дните на
  // Христина, а щом човек цъкнеше такъв ден при Мила, часовете бяха празни.
  var самоГрад = безИмена() ? градътНаИзбора() : null;
  (ПОНИВА[ИЗБРАНО] || []).forEach(function(r){
    if(самоГрад){ if(r.grad && r.grad !== самоГрад) return; }
    else if(избор.specialist && r.staff !== избор.specialist) return;
    if(!вБъдещето(r)) return;   // иначе днешният ден светва, а вътре е празно
    if(редДни.indexOf(r.den) < 0) редДни.push(r.den);
  });
  редДни.sort();
  редДни.forEach(function(d){
    if(!заДеня(d).length) return;
    var к = d.slice(0,7);
    if(м.indexOf(к) < 0) м.push(к);
  });
  return м.sort();
}

function нарисувайДни(){
  var к = $('rez-dni');
  месециСъсСвободно();

  if(!редДни.length){
    к.innerHTML = '<div class="rez-chaka">При ' + (избор.specialist || 'този специалист') +
      ' няма свободно в следващите два месеца. Пробвай друг специалист или се обади на ' +
      '' + телЛинк() + '.</div>';
    избор.den = null;
    return;
  }

  // Един месец наведнъж. Лентата с всички месеци един до друг се
  // плъзгаше настрани и влачеше цялата страница с нея; освен това човек
  // не виждаше в кой месец е, докато не стигне надписа. Сега се отваря
  // месецът с първия свободен час, а със стрелките се минава напред и
  // назад, само през месеците, в които наистина има свободно.
  var месеци = месециСъсСвободно();
  if(месеци.indexOf(избор.mesec) < 0) избор.mesec = (избор.den && избор.den.slice(0,7)) || месеци[0];
  if(месеци.indexOf(избор.mesec) < 0) избор.mesec = месеци[0];
  var i = месеци.indexOf(избор.mesec);

  var чипове = '';
  редДни.forEach(function(iso){
    if(iso.slice(0, 7) !== избор.mesec) return;
    var d = new Date(iso + 'T00:00:00');
    чипове += '<button class="rez-den' + (iso === избор.den ? ' on' : '') + '"' +
              ' data-den="' + iso + '">' +
              '<span>' + КРАТКИ_ДНИ[d.getDay()] + '</span><b>' + d.getDate() + '</b></button>';
  });

  var име = МЕСЕЦИ[+избор.mesec.slice(5, 7) - 1] + ' ' + избор.mesec.slice(0, 4);
  к.innerHTML =
    '<div class="rez-etiket">Кой ден</div>' +
    '<div class="rez-mesec-red">' +
      '<button class="rez-mesec-strelka" type="button" data-mesec-hod="-1"' +
        (i > 0 ? '' : ' disabled') + ' aria-label="Предишен месец">\u2039</button>' +
      '<b id="rez-mesec-sega">' + име + '</b>' +
      '<button class="rez-mesec-strelka" type="button" data-mesec-hod="1"' +
        (i < месеци.length - 1 ? '' : ' disabled') + ' aria-label="Следващ месец">\u203A</button>' +
    '</div>' +
    '<div class="rez-lenta" id="rez-lenta">' + чипове + '</div>';

  // Денят НЕ се избира сам.
  //
  // Досега първият свободен ден стоеше черен, все едно е избран, а
  // часовете отдолу бяха за него. Жените го четяха като „вече решено" и
  // не разбираха, че трябва да цъкнат. Габриела Донева се опитва цял ден
  // и се отказа. Антонио, 09.10.2026: „датата да не е избрана, часовете
  // да са скрити, и щом цъкне дата, тя се свива и дава часовете за нея."
  //
  // Ако избраният ден вече го няма в този месец, пада: по-добре нищо
  // избрано, отколкото тихо прехвърлено на друг ден.
  if(избор.den && (!заДеня(избор.den).length || избор.den.slice(0,7) !== избор.mesec)){
    избор.den = null;
    избор.chas = null;
  }
  [].forEach.call(к.querySelectorAll('[data-den]'), function(b){
    b.classList.toggle('on', !!избор.den && b.dataset.den === избор.den); });
}

// Стрелките минават само през месеците със свободно: ако при Мила няма
// нищо през ноември, от октомври се отива право на февруари.
function сменѝМесец(посока){
  var месеци = месециСъсСвободно();
  var i = месеци.indexOf(избор.mesec) + посока;
  if(i < 0 || i >= месеци.length) return;
  избор.mesec = месеци[i];
  избор.den = null;
  избор.chas = null;
  нарисувайДни();
  нарисувайЧасове();
  свито.den = false; свито.chas = false;
  подредиСтъпките();
}

function нарисувайЧасове(){
  // Без избран ден няма какво да се показва: подканяме, вместо да сипем
  // часовете на произволен ден.
  if(!избор.den){
    var к0 = $('rez-chasove');
    if(к0) к0.innerHTML = '<div class="rez-etiket">В колко часа</div>' +
      '<div class="rez-podkana">Първо избери дата отгоре.</div>';
    return;
  }

  var к = $('rez-chasove');
  if(!избор.den){ к.innerHTML='<div class="rez-chaka">Избери ден от календара.</div>'; return; }
  var списък = заДеня(избор.den);
  if(!списък.length){ к.innerHTML='<div class="rez-chaka">Този ден е зает. Избери друг.</div>'; return; }

  к.innerHTML = '<div class="rez-etiket">В колко часа · ' + денОтИсо(избор.den) + ', ' + датаБГ(избор.den) + '</div>' +
    '<div class="rez-mrezha">' + списък.map(function(r){
      var чч = r.nachalo.slice(0,5);
      // Градът стои до името, когато салоните са повече от един. На
      // „Запази час" жената не минава през избора на специалист и досега
      // нямаше как да разбере, че часът ѝ е в Стара Загора.
      var град = (r.grad || '').trim();
      var подпис = (БЕЗ_ИМЕ ? '' : r.staff.split(' ')[0] + (град ? ' · ' : '')) + (град || '');
      return '<button class="rez-chas" data-chas="'+r.nachalo+'" data-staff="'+r.staff_id+'" data-ime="'+r.staff+'">' +
        '<b>'+чч+'</b><span>'+подпис+'</span></button>';
    }).join('') + '</div>';
}

// ---------------------------------------------------------------- потвърждение
// Едно нещо на екрана: докато няма избран час, няма и сметка.
// Какво още чакаме от жената. Блокът с бутона се появява чак след ден и
// час, затова дотогава тя натиска „Запази час" горе и нищо не се случва.
// Антонио, 09.10.2026: „показвай им какво искаме от тях."
//
// Редът стои под календара, казва следващото нещо и води до него.
function следващаСтъпка(){
  var ВСИЧКИ = ['usl-hora','rez-dni','rez-chasove','rez-kontakt','rez-plati'];
  ВСИЧКИ.forEach(function(ид){
    var у = document.getElementById(ид);
    if(у) у.classList.remove('rez-pulsira');
  });
  var старо = document.getElementById('rez-sled');
  if(старо) старо.remove();

  var къде = null;
  if(!избор.specialist)      къде = 'usl-hora';
  else if(!избор.den)        къде = 'rez-dni';
  else if(!избор.chas)       къде = 'rez-chasove';
  else {
    var и = $('rez-ime'), тел = $('rez-tel');
    if((и && !и.value.trim()) || (тел && !тел.value.trim())) къде = 'rez-kontakt';
    // Няма ли какво да се попълва, остава само едно: бутонът. Той
    // пулсира, както „Готово" при лазера. Антонио, 11.10.2026.
    else къде = 'rez-plati';
  }
  if(!къде){ ПОСЛЕДНА_ЦЕЛ = null; return; }

  var цел = document.getElementById(къде);
  if(цел) цел.classList.add('rez-pulsira');

  // Връщаме я горе при самото място, щом стъпката се смени: инак след
  // избора на зони страницата я оставя долу и тя не вижда календара.
  if(цел && къде !== ПОСЛЕДНА_ЦЕЛ){
    ПОСЛЕДНА_ЦЕЛ = къде;
    if(ПЪРВОТО_РИСУВАНЕ){ ПЪРВОТО_РИСУВАНЕ = false; return; }
    setTimeout(function(){ цел.scrollIntoView({block:'center', behavior:'smooth'}); }, 220);
  }
}
var ПОСЛЕДНА_ЦЕЛ = null;
var ПЪРВОТО_РИСУВАНЕ = true;

function покажиСметката(да){
  var к = $('rez-potvardi');
  if(!к) return;
  к.hidden = !да;
  if(да){
    // Сумата стои на бутона — един ред вместо таблица. Трите свити реда
    // отгоре вече казват какво, кога и при кого.
    var б = $('rez-plati');
    if(б) б.textContent = КАПАРО > 0 ? ('Плати капарото · ' + евро(КАПАРО)) : 'Запази часа';
    пусниТаймер();
  }
  else   { сприТаймер(); }
}

function пусниТаймер(){
  var край = Date.now() + 15*60*1000;
  var к = $('rez-taymer');
  сприТаймер();
  function тик(){
    var о = Math.max(0, край - Date.now());
    var м = Math.floor(о/60000), с = Math.floor((о%60000)/1000);
    к.innerHTML = о ? ('Часът ти е запазен още <b>' + м + ':' + (с<10?'0':'') + с + '</b> минути')
                    : 'Времето изтече. Избери час наново.';
    if(!о){ сприТаймер(); избор.chas = null; свито.chas = false; подредиСтъпките(); }
  }
  тик();                       // иначе първата секунда редът стои празен
  таймер = setInterval(тик, 1000);
}
function сприТаймер(){ if(таймер){ clearInterval(таймер); таймер=null; } $('rez-taymer').innerHTML=''; }


// Данните, които човекът вече е написал, се подават на касата, за да не ги
// пише втори път.
//
// Пътят е /cart/c/{номер на количката}?...: само той и попълва, и запазва
// количката със свойствата. Пробвани и отхвърлени:
//   · /checkout?checkout[...] → приема адреса, но параметрите се губят при
//     пренасочването и касата излиза празна (проверено на телефон)
//   · /cart/вариант:1?checkout[...] → попълва, но прави НОВА количка и
//     свойствата, в които пътуват името и часът, изчезват
//   · свойства на постоянния линк → 422, всякакви
function къмКасатаДанни(съединител){
  var ч = [];
  // Полетата се четат от страницата, не от променливи: те живеят вътре в
  // къмКасата() и оттук не се виждат.
  var п = function(ид){ var е = $(ид); return (е && е.value || '').trim(); };
  var име = п('rez-ime'), тел = п('rez-tel'), мейл = п('rez-mail');
  if(мейл) ч.push('checkout[email]=' + encodeURIComponent(мейл));
  if(име){
    // Първата дума е името, останалото фамилията. Жена с три имена
    // получава второто и третото във фамилното поле, което е по-добре от
    // изгубено име.
    var части = име.split(/\s+/);
    ч.push('checkout[billing_address][first_name]=' + encodeURIComponent(части[0]));
    if(части.length > 1) ч.push('checkout[billing_address][last_name]=' + encodeURIComponent(части.slice(1).join(' ')));
  }
  if(тел) ч.push('checkout[billing_address][phone]=' + encodeURIComponent(тел));
  ч.push('checkout[billing_address][country]=Bulgaria');
  // Линкът на количката вече носи ?key=, затова следващото е с &.
  return ч.length ? ((съединител || '?') + ч.join('&')) : '';
}
// Черновата на поръчка: единственият начин касата да излезе попълнена.
//
// Защо изобщо: на 25.10.2026 на последния бутон излизаха три червени
// грешки — адрес, пощенски код и град — за резервация на час за 0 €.
// В Shopify адресът не се маха (проверено в тяхната документация; на
// план Basic касата не се редактира), но ЧЕРНОВАТА го приема наготово.
// Антонио: „Адресът не ни интересува, човекът идва в салона."
//
// Връща линк или null. null значи „мини по стария път", не „спри".
function презЧерновата(вариант, свойства){
  if(!КРАЙ) return Promise.resolve(null);
  return fetch(КРАЙ + '/api/chernova', {
    method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({ variant: вариант, svoystva: свойства })
  })
  .then(function(r){ return r.ok ? r.json() : null; })
  .then(function(о){ return (о && о.invoice_url) ? о.invoice_url : null; })
  .catch(function(){ return null; });
}

// Старият път, непокътнат. Пази се нарочно: ако нашата точка падне или
// Shopify откаже черновата, записването пак минава.
//
// Пътят е /cart/c/{номер на количката}: само той и попълва, и запазва
// свойствата. Другите два са пробвани и отхвърлени, виж къмКасатаДанни.
function презКоличката(КОРЕН, вариант, свойства){
  return fetch(КОРЕН + '/cart/clear.js', { method:'POST' })
    .then(function(){
      return fetch(КОРЕН + '/cart/add.js', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ id: вариант, quantity: 1, properties: свойства })
      });
    })
    .then(function(r){ if(!r.ok) return r.text().then(function(t){ throw new Error(t.slice(0,150)); }); })
    .then(function(){ return fetch(КОРЕН + '/cart.js').then(function(r){ return r.json(); }); })
    .then(function(к){
      window.location.href = (к && к.token)
        ? (КОРЕН + '/cart/c/' + к.token + къмКасатаДанни('&'))
        : (КОРЕН + '/checkout');
    });
}

// ---------------------------------------------------------------- касата
function къмКасата(){
  // Вариантът за точната сума. Няма ли го, слиза се до най-близката
  // по-малка: жената плаща малко по-малко капаро, вместо бутонът да спре.
  // При зони сумите са много и не всяка има свой вариант.
  var вариант = ВАРИАНТИ[String(Math.round(КАПАРО))];
  if(!вариант){
    var сумите = Object.keys(ВАРИАНТИ).map(Number).sort(function(a,b){ return a-b; });
    var най = null;
    сумите.forEach(function(x){ if(x <= КАПАРО) най = x; });
    if(най != null){ вариант = ВАРИАНТИ[String(най)]; КАПАРО = най; }
  }
  var г = $('rez-greshka3');
  if(!триажГотов()){
    г.textContent = ТРИАЖ.вид === 'poddrazhka'
      ? 'За поддръжка първо качи снимка на веждите.'
      : 'Първо отговори дали имаш стар перманентен грим.';
    рисувайТриаж(); var т = $('rez-triazh'); if(т) т.scrollIntoView({block:'center'});
    return;
  }
  if(!вариант){ г.textContent = 'Тази сума още не е настроена. Обади се на ' + телПис() + '.'; return; }

  г.textContent = '';

  var край = (function(){
    var ч = избор.chas.split(':');
    var d = new Date(избор.den + 'T' + избор.chas);
    d.setMinutes(d.getMinutes() + ТРАЕНЕ);
    return ('0'+d.getHours()).slice(-2) + ':' + ('0'+d.getMinutes()).slice(-2);
  })();

  // Име и телефон се питат ТУК и пътуват като свойства на реда.
  //
  // Не е излишно питане: магазинът е на Shopify Basic без одобрена
  // Protected Customer Data, затова в поръчката името, телефонът и
  // имейлът идват празни. Доказано на #1029 и #1030: картонът при Ади
  // излезе „От сайта", без телефон и без имейл. Касата ги събира, но
  // ние нямаме право да ги прочетем.
  //
  // Имената на свойствата са точно тези, които webhook-ът чака:
  // „Клиентка", „Телефон" и „_мейл". Сменят се заедно или никак.
  var пИме  = $('rez-ime');
  var пТел  = $('rez-tel');
  var пМейл = $('rez-mail');
  var грК   = $('rez-kontakt-greshka');

  function кажиК(т){ if(грК){ грК.hidden = !т; грК.textContent = т || ''; } }

  var име = (пИме && пИме.value || '').trim();
  var тел = (пТел && пТел.value || '').replace(/[^\d+]/g, '');
  if(тел.charAt(0) === '0') тел = '+359' + тел.slice(1);
  var мейл = (пМейл && пМейл.value || '').trim().toLowerCase();

  // Ако шаблонът няма полетата, не спираме: по-добре час без име,
  // отколкото бутон, който мълчи. Това вече се случи веднъж.
  if(пИме && име.length < 2){
    кажиК('Напиши името си, за да знаем кой идва.');
    пИме.focus(); return;
  }
  if(пТел && тел.replace(/\D/g, '').length < 9){
    кажиК('Напиши телефон: обаждаме се, за да потвърдим часа.');
    пТел.focus(); return;
  }
  кажиК('');
  var свойства = {
    'Процедура': (ИМЕ_ЗОНИ || ИМЕ),
    'Ден и час': денОтИсо(избор.den) + ', ' + датаБГ(избор.den) + ' в ' + избор.chas.slice(0,5),
    'Специалист': избор.specialist_ime || 'който е свободен',
    'Продължителност': ТРАЕНЕ + ' минути',
    '_дата': избор.den,
    '_начало': избор.chas,
    '_край': край,
    '_usluga': ИЗБРАНО,
    '_pylna': String(ПЪЛНА),
    '_staff': избор.staff_id || '',
    '_minuti': String(ТРАЕНЕ)
  };

  // Имената са тези, които api/porachka.js чете. Празно свойство не се
  // праща: на касата се вижда като ред без стойност.
  // Зоните влизат като свойство: оттам webhook-ът ги слага в бележката на
  // часа и Ади вижда какво точно е избрано.
  if(ЗОНИ) свойства['Зони'] = ЗОНИ;
  // Кой сеанс, коя зона, кой град: думите, с които жената е избрала.
  // Без тях в картона стои само името на услугата, а втори и пети лазер
  // са една и съща услуга.
  if(window.MILA_IZBOR_TEKST) свойства['Избор'] = window.MILA_IZBOR_TEKST;
  if(ПАКЕТ > 1) свойства['Пакет'] = 'Пакет ' + ПАКЕТ + ' сеанса, 1/' + ПАКЕТ;
  if(име)  свойства['Клиентка'] = име;
  if(тел)  свойства['Телефон']  = тел;
  // Същото, но скрито: Shopify крие личните данни от приложението
  // (Protected customer data), затова единственият сигурен път към
  // CRM-а и календара минава оттук. Поръчка #1043 влезе без име и без
  // телефон точно защото тези редове ги нямаше. 12.10.2026.
  if(име)  свойства['_ime']     = име;
  if(тел)  свойства['_telefon'] = тел;

  // Откъде е дошла. Shopify пише „/" за всяка поръчка, защото пътят през
  // /cart/c губи следата — на 12.10.2026 четири поръчки излязоха без
  // източник. Затова го носим сами. Без лични данни: само домейн и
  // „да/не" за идентификатора на клика.
  try{
    if(typeof window.MILA_IZVOR === 'function'){
      var из = window.MILA_IZVOR();
      if(из.izvor)    свойства['_izvor'] = из.izvor;
      if(из.posleden && из.posleden !== из.izvor) свойства['_izvor_posleden'] = из.posleden;
      if(из.ref)      свойства['_referrer_domain'] = из.ref;
      if(из.landing)  свойства['_landing'] = из.landing;
      if(из.gclid)    свойства['_gclid'] = из.gclid;
      if(из.fbclid)   свойства['_fbclid'] = из.fbclid;
    }
  }catch(e){}
  if(мейл) свойства['_мейл']    = мейл;

  // Не пишем „за доплащане", защото в този миг още не се знае как ще плати.
  // Избере ли плащане на място, тя не дава нищо онлайн и дължи цялата сума.
  // Затова се казват двете числа, а салонът вади разликата от самата поръчка.
  свойства['Пълна цена'] = евро(ПЪЛНА);
  if(ПРОМО){
    свойства['Код за отстъпка'] = ПРОМО.kod + ' (\u2212' + ПРОМО.procent + '%)';
    свойства['Цена без отстъпка'] = евро(ЦЕНА_БЕЗ_ПРОМО);
  }
  if(КАПАРО) свойства['Капаро, ако плати онлайн'] = евро(КАПАРО);
  if(ТРИАЖ.вид === 'mikroblejding') свойства['Стар перманентен грим'] = 'Не';
  if(ТРИАЖ.снимка){ свойства['Снимка на веждите'] = 'изпратена'; свойства['_snimka'] = ТРИАЖ.снимка; }

  var б = $('rez-plati'); б.disabled = true; б.textContent = 'Момент…';

  var КОРЕН = window.MILA_KOREN || '';

  // Слотът се заделя ПРЕДИ касата. Докато жената си въвежда картата, той
  // вече не се предлага на никого. Не дойдат ли парите до срока,
  // заделянето пада само и слотът пак излиза.
  викни('zadeli_slot', {
    p_service: ИЗБРАНО,
    p_staff:   избор.staff_id,
    p_start:   софийскоВUTC(избор.den, избор.chas).toISOString(),
    p_minutes: ТРАЕНЕ
  })
  .then(function(ид){
    if(!ид){
      // някой е платил за същия час, докато тя е решавала
      б.disabled = false; б.textContent = КАПАРО > 0 ? ('Плати капарото · ' + евро(КАПАРО)) : 'Запази часа';
      г.textContent = 'Този час се зае преди малко. Избери друг.';
      избор.chas = null; свито.chas = false;
      нарисувайДни(); нарисувайЧасове(); подредиСтъпките();
      throw new Error('слотът се зае');
    }
    свойства['_zayavka'] = ид;
    // Първо се пробва черновата: тя носи адреса на салона и касата
    // излиза попълнена. Не стане ли, се минава по стария път през
    // количката. По-добре каса с пет полета, отколкото бутон, който
    // мълчи.
    return презЧерновата(вариант, свойства);
  })
    .then(function(линк){
      if(линк){ window.location.href = линк; return null; }
      return презКоличката(КОРЕН, вариант, свойства);
    })
    .catch(function(e){
      $('rez-greshka3').textContent = 'Нещо се обърка: ' + e.message;
      б.disabled = false; б.textContent = КАПАРО > 0 ? 'Плати капарото' : 'Запази часа';
    });
}


// Стъпките: показваме само това, което още не е решено. Свършеното става
// един ред с избраното и „смени". Взето от резервацията на Анели —
// там този ред се оказа разликата между три екрана и едно решение.
function подредиСтъпките(){
  var двойки = [
    ['den',  'rez-dni',     'rez-red-den',   редДен],
    ['chas', 'rez-chasove', 'rez-red-chas',  редЧас]
  ];
  // Готово значи ИЗБРАНИ ден и час, не „свити" ден и час.
  //
  // Вчера направих календара да скача сам на най-ранния свободен ден.
  // Денят се избираше програмно, затова свито.den оставаше false, и ако
  // жената цъкнеше само час, формата с името и телефона НЕ се показваше.
  // Бутонът „Запази час" я връщаше при часовете и обикаляше в кръг.
  //
  // Габриела Донева, 08.10.2026: „цял ден се опитвам и не ми дава… само
  // ме върти на едно и също." Загубен час, защото едно условие гледаше
  // състоянието на екрана вместо избора.
  var готово = !!(избор.den && избор.chas);
  покажиСметката(готово);
  следващаСтъпка();

  двойки.forEach(function(д){
    var пълно = $(д[1]), ред = $(д[2]);
    if(!пълно || !ред) return;
    var текст = свито[д[0]] ? д[3]() : null;
    if(текст){
      пълно.hidden = true;
      ред.hidden = false;
      ред.innerHTML = '<b>' + текст + '</b><i>смени</i>';
    } else {
      пълно.hidden = false;
      ред.hidden = true;
    }
  });
}

function редДен(){
  if(!избор.den) return null;
  return денОтИсо(избор.den) + ', ' + датаБГ(избор.den);
}
function редЧас(){
  if(!избор.chas) return null;
  var d = new Date(избор.den + 'T' + избор.chas);
  var край = new Date(d.getTime() + ТРАЕНЕ*60000);
  var дв = function(n){ return ('0'+n).slice(-2); };
  return избор.chas.slice(0,5) + ' – ' + дв(край.getHours()) + ':' + дв(край.getMinutes());
}


// Дойде ли човекът от менюто с ?nivo=…, той вече е избрал кое ниво иска.
// Отваряме точно него и му показваме първия свободен ден, вместо да го
// караме да повтаря избора си.
// Избор на ниво отвън: едната страница на семейство („Премахване на стрии")
// има чипове за зона и брой сеанси, а всяка комбинация е отделна услуга в
// базата. Чиповете викат това, вместо да водят на 26 различни страници.
// Връща false, когато услугата я няма: тогава чипът се показва като зает.
// Траенето следва избраното ниво. Без това часът се заделя за времето
// на продукта носител и графикът на специалистката лъже.
function приложиНивоТраене(услуга){
  var м = ТРАЕНЕ_НА[услуга];
  if(!м || ПО_ЗОНИ) return;        // при зоните сборът вече е сметнат
  покажиТраене(м);
  // И тук накрая, защото MILA_OGRANICHI вика тази функция СЛЕД
  // приложиЦена: без този ред общото време се връщаше върху личното.
  покажиТраене(времеЗа(услуга, избор.specialist));
}

function изберѝНиво(услуга){
  var р = РЕДОВЕ.filter(function(x){ return x.usluga === услуга; })[0];
  if(!р) return false;

  ИЗБРАНО = р.usluga;
  избор.specialist = р.staff;
  ЦЕНА_ОТ_ЧИПА = null;        // сървърът потвърди: списъкът пак командва
  приложиНивоТраене(р.usluga);
  приложиЦена();
  опишиИзбора();
  [].forEach.call(document.querySelectorAll('[data-hora]'), function(b){
    b.classList.toggle('on', b.dataset.hora === р.staff && b.dataset.usluga === р.usluga);
  });
  избор.den = р.parvi;
  избор.mesec = р.parvi.slice(0,7);
  избор.chas = null;          // часът на старата услуга не важи за новата
  свито.den = false;

  // Тук беше грешката: викаше се заДеня(), която само ИЗЧИСЛЯВА списък и
  // го връща. Календарът не се преначертаваше, затова след „Стара Загора"
  // горе стоеше цената на Стара Загора, а часовете бяха на Грета в София.
  // Жената плащаше едното и се записваше за другото.
  нарисувайДни();
  нарисувайЧасове();
  подредиСтъпките();
  return true;
}
window.MILA_IZBERI_NIVO = изберѝНиво;

// Свива избора до тези услуги и преначертава всичко отдолу. Връща кои
// хора са останали, за да може страницата да зачеркне това, което
// избраният човек не прави.
window.MILA_OGRANICHI = function(списък){
  // Истински избор: списъкът не си отива, само се опреснява, за да не
  // остане със стари дати, след като часовете са се преизчислили.
  setTimeout(нарисувайОткрития, 0);
  ДОПУСТИМИ = (списък && списък.length) ? списък.slice() : null;
  var редове = нарисувайХора();
  if(!редове || !редове.length) return [];
  // Траенето следва избраната услуга, не носителя.
  приложиНивоТраене(ИЗБРАНО);

  // Щом изборът се смени, отиваме на месеца с най-ранното свободно, но
  // ДЕН не избираме. Вчера го избирах сам и денят стоеше черен, все едно
  // е решен — точно това обърка Габриела. Антонио, 09.10.2026: „да няма
  // дати преди това."
  var най_ран = null;
  редове.forEach(function(r){
    (ПОНИВА[r.usluga] || []).forEach(function(x){
      if(x.staff !== r.staff) return;
      if(!най_ран || x.den < най_ран) най_ран = x.den;
    });
  });
  if(най_ран){
    избор.mesec = най_ран.slice(0,7);
    избор.den = null;
    избор.chas = null;
    свито.den = false;
    свито.chas = false;
  }

  нарисувайДни();
  нарисувайЧасове();
  подредиСтъпките();
  опресниТриажа();
  опресниПоканата();
  return редове.map(function(r){ return {usluga:r.usluga, staff:r.staff, grad:r.grad, cena:r.cena}; });
};
// Изборът на зони от същата страница. Вика се от mila-lazer.js, когато
// той е вграден в продукта: вместо да праща на друг адрес, подава сбора
// и резервацията се преизчислява на място.
window.MILA_ZONI_PRILOJI = function(д){
  if(!д || !(д.suma > 0) || !(д.minuti > 0)) return false;
  document.body.classList.remove('laz-bez-izbor');
  ЗОНИ = д.zoni || '';
  ПО_ЗОНИ = true;
  ПАКЕТ = (д.sesii > 1) ? д.sesii : 0;
  // Същото правило и когато зоните се избират на място: до три ги
  // изброяваме, повече — броят.
  var спЗ = ЗОНИ ? ЗОНИ.split('|').filter(Boolean) : [];
  var брой = спЗ.length || 1;
  ИМЕ_ЗОНИ = 'Лазерна епилация · ' + (спЗ.length && спЗ.length <= 3
    ? спЗ.join(', ').toLowerCase()
    : брой + ' зони');
  (function(){
    var з = document.querySelector('.usl-ime');
    if(з) з.innerHTML = ИМЕ_ЗОНИ.replace(' · ', '&nbsp;· ');
    try{ document.title = ИМЕ_ЗОНИ + ' – Mila Savage Beauty'; }catch(e){}
  })();
  ПЪЛНА = д.suma;
  ТРАЕНЕ = д.minuti;
  // Същото правило като при зоните от адреса: капароЗаЗоните().
  КАПАРО = капароЗаЗоните();
  ОСТАТЪК = ПЪЛНА - КАПАРО;
  // Времето под цената също следва избора: при две зони по 15 минути
  // горе пишеше „90 минути" — колкото е носещата услуга, не часът.
  var т = document.getElementById('usl-traene');
  if(т){
    т.hidden = false;
    т.textContent = (ТРАЕНЕ >= 60)
      ? (Math.floor(ТРАЕНЕ/60) + ' ч' + (ТРАЕНЕ%60 ? ' ' + (ТРАЕНЕ%60) + ' мин' : ''))
      : (ТРАЕНЕ + ' минути');
  }
  приложиЦена();
  пусни();
  return true;
};

window.MILA_ZADAI_CENA = function(цена, минути){
  if(ПО_ЗОНИ) return;                       // при зоните сборът командва
  if(цена != null && !isNaN(цена) && цена > 0){
    ПЪЛНА = Number(цена);
    ЦЕНА_ОТ_ЧИПА = ПЪЛНА;
    var к = Math.ceil((ПЪЛНА * 0.2) / 5) * 5;
    if(!КАПАРО || КАПАРО > ПЪЛНА) КАПАРО = Math.max(10, Math.min(к, ПЪЛНА));
    ОСТАТЪК = Math.max(0, ПЪЛНА - Math.min(КАПАРО, ПЪЛНА));
    приложиЦена();
  }
  if(минути != null && !isNaN(минути) && минути > 0){
    // Времето при избрания човек бие общото на продукта. Страницата
    // подава 60, колкото стои на услугата, а при Грета са 180 и при
    // Христина 120. Тази функция се вика ПОСЛЕДНА, след приложиЦена, и
    // досега затриваше вече написаното вярно време. Точно това Ади
    // виждаше на 16.10.2026: €450 и „1 ч" на един ред.
    покажиТраене(времеЗа(ИЗБРАНО, избор.specialist) || минути);
  }
};

window.MILA_KOY_E_IZBRAN = function(){ return избор.specialist || null; };
window.MILA_AKTIVNA_USLUGA = function(){ return ИЗБРАНО || null; };

function отвориИсканото(){
  var искано;
  try{ искано = new URLSearchParams(location.search).get('nivo'); }catch(e){ return; }
  if(!искано) return;
  var р = РЕДОВЕ.filter(function(x){ return x.usluga === искано; })[0];
  if(!р) return;

  ИЗБРАНО = р.usluga;
  избор.specialist = р.staff;
  приложиЦена();
  опишиИзбора();
  [].forEach.call(document.querySelectorAll('[data-hora]'), function(b){
    b.classList.toggle('on', b.dataset.hora === р.staff && b.dataset.usluga === р.usluga);
  });
  избор.den = р.parvi;
  избор.mesec = р.parvi.slice(0,7);
  свито.den = true;
}

// ---------------------------------------------------------------- кликове
сек.addEventListener('click', function(ев){
  var t = ев.target.closest('button');
  if(!t) return;

  if(t.dataset.otvori){
    свито[t.dataset.otvori] = false;
    // отвориш ли по-ранна стъпка, следващите пак чакат решение
    if(t.dataset.otvori === 'den'){ свито.chas = false; }
    подредиСтъпките();
    return;
  }
  if(t.dataset.hora !== undefined){ смениНиво(t); return; }
  if(t.dataset.mesecHod){ сменѝМесец(+t.dataset.mesecHod); return; }
  if(t.dataset.den){
    [].forEach.call(сек.querySelectorAll('[data-den]'), function(b){ b.classList.toggle('on', b===t); });
    избор.den = t.dataset.den;
    избор.chas = null;
    нарисувайЧасове();
    свито.den = true; свито.chas = false;
    подредиСтъпките();
    return;
  }
  if(t.dataset.chas){
    избор.chas = t.dataset.chas;
    избор.staff_id = t.dataset.staff;
    избор.specialist_ime = t.dataset.ime;
    обявиСпециалистка();
    // Капарото се решава от човека, който ще прави процедурата, а той е
    // записан на самия час. Това е най-сигурното място: тук няма
    // разминаване между име и идентификатор.
    var кап = ПОКАПАРО[ИЗБРАНО + '|' + избор.staff_id];
    if(!ПО_ЗОНИ && кап != null && !isNaN(кап)){
      КАПАРО = кап;
      ОСТАТЪК = Math.max(0, ПЪЛНА - Math.min(КАПАРО, ПЪЛНА));
    }
    if(ПО_ЗОНИ){
      КАПАРО = капароЗаЗоните();
      ОСТАТЪК = Math.max(0, ПЪЛНА - Math.min(КАПАРО, ПЪЛНА));
      приложиЦена();
    }
    свито.chas = true;
    подредиСтъпките();
    return;
  }

  if(t.id === 'rez-plati'){ къмКасата(); return; }
});

// Слуша се ДОКУМЕНТЪТ, не блокът.
//
// Дотук слушателят висеше на #usl (процедурната страница) или на самата
// секция. Откакто „стъпка по стъпка" мести списъка с хора в отделен
// екран, той вече не е вътре в #usl и кликът нямаше до кого да стигне:
// жената натиска Мила и нищо не се случва. Условията долу са достатъчно
// точни (id-то и data-hora), за да няма значение къде седи елементът.
// Същата причина, поради която и триажът слуша документа.
var горе = document;
if(горе) горе.addEventListener('click', function(ев){
  var t = ев.target.closest('button');
  if(!t) return;
  if(t.id === 'usl-glava'){ ев.preventDefault(); отвориСписъка(); return; }
  if(t.dataset.hora !== undefined){
    // Откритият списък си има свой път (`презЧипа`): първо чипът, после
    // човекът, после екранът. Мине ли и оттук, човекът се сменя ВТОРИ
    // път и месецът се нулира пак — тогава екранът спира на „При кого"
    // с празно отдолу. Антонио го хвана на телефона, 27.10.2026.
    if(t.closest && t.closest('#usl-otkrit')) return;
    ев.preventDefault();
    отвориХора(t);
    опишиИзбора();
    отвориСписъка(false);
  }
});

// клик встрани затваря списъка
document.addEventListener('click', function(ев){
  var д = $('usl-hora');
  // Преди първия избор списъкът НЕ се затваря от клик встрани: инак
  // лицата, заради които го отворихме, изчезват при първото докосване
  // на страницата.
  if(д && !д.contains(ев.target) && РЪЧНО_ИЗБРАН) отвориСписъка(false);
});
document.addEventListener('keydown', function(ев){
  if(ев.key === 'Escape') отвориСписъка(false);
});

// Коя специалистка е избрана в момента. Блокът „Защо да ми се довериш"
// долу на страницата слуша това, за да покаже нейния текст, а не чужд:
// жената чете „аз съм Мила", а часът ѝ е при Грета.
function обявиСпециалистка(){
  var име = избор.specialist_ime || избор.specialist || '';
  document.dispatchEvent(new CustomEvent('mila:specialistka', {detail:{ime: име}}));
}

// Натиснат ред, докато списъкът стои открит: първо чипът, после човекът.
//
// Чипът се НАТИСКА, не се подменя състояние: `смени()` в семейството е
// синхронна и дърпа MILA_OGRANICHI, което преначертава редовете. Затова
// човекът се хваща ПАК след натискането, от новата разметка.
function презЧипа(t){
  var ч = чипътПървична();
  if(!ч || ч.disabled) return false;
  var кой = t.dataset.hora || '', каква = t.dataset.usluga || '';
  try{ ч.click(); }catch(e){ return false; }
  // Списъкът остава. Екранът го покрива, докато е отворен, а затвори ли
  // се, жената пак го вижда.
  // Човекът се търси САМО в списъка на екрана и се НАТИСКА, не се
  // подменя състояние. Причината е в mila-stapki.js: стъпката „При кого"
  // е готова само ако жената е натиснала `[data-hora]`, а натискането на
  // чипа току-що е нулирало този отговор. Истинско натискане го връща.
  var вътре = document.getElementById('usl-hora');
  var нов = null;
  if(вътре) [].forEach.call(вътре.querySelectorAll('[data-hora]'), function(b){
    if(!нов && b.dataset.hora === кой && (!каква || b.dataset.usluga === каква)) нов = b;
  });
  if(нов) нов.click();

  // МЕСЕЦЪТ СЕ ВРЪЩА. `смениНиво` нулира ден, месец и час — вярно е,
  // когато жената сменя човека на ръка. Тук обаче чипът току-що е
  // наместил месеца на най-ранното свободно (`MILA_OGRANICHI`), а
  // нулирането го изтрива веднага след това. Резултатът го видя Антонио
  // на телефона, 27.10.2026: влиза втори път, горе стои Грета, а отдолу
  // няма нито един ден — екранът спира на „При кого", защото няма какво
  // да покаже, и трябва пак да се цъка по името.
  //
  // Затова месецът се нагласява по първия свободен ден на ТОЗИ човек,
  // а денят и часът остават неизбрани: тях ги избира жената.
  if(нов){
    var р = (РЕДОВЕ || []).filter(function(x){
      return x.staff === кой && (!каква || x.usluga === каква); })[0];
    if(р && р.parvi){
      избор.mesec = р.parvi.slice(0, 7);
      нарисувайДни();
      нарисувайЧасове();
      подредиСтъпките();
    }
  }

  // И се отваря самият екран, на стъпката, която е наред: въпросът за
  // стария грим, ако още не е отговорен, иначе денят и часът. Бутонът се
  // натиска, вместо да се пипа екранът: така `mila-stapki.js` сам си
  // пресмята коя стъпка показва.
  var б = document.querySelector('.st-pusk-btn') ||
          document.querySelector('[data-st="otvori"]');
  if(б) setTimeout(function(){ try{ б.click(); }catch(e){} }, 20);
  return true;
}

function смениНиво(t){
  // Жената сама отвори списъка и натисна човек: оттук нататък лентата
  // показва неговите дни, а не целия екип.
  РЪЧНО_ИЗБРАН = true;
  избор.specialist = t.dataset.hora || null;
  ИЗБРАНО = t.dataset.usluga || ИЗБРАНО;
  избор.specialist_ime = null;   // новото ниво още няма избран час
  обявиСпециалистка();
  [].forEach.call(document.querySelectorAll('[data-hora]'), function(b){
    b.classList.toggle('on', b.dataset.hora === (избор.specialist||'')
                           && b.dataset.usluga === ИЗБРАНО); });
  приложиЦена();
  опишиИзбора();
  избор.den = null; избор.mesec = null; избор.chas = null;
  нарисувайДни();
  нарисувайЧасове();
  // Избереш ли, списъкът се затваря сам. Иначе стои отворен и покрива
  // календара, а човекът не се сеща, че трябва да цъкне пак.
  отвориСписъка(false);
  свито.den = false; свито.chas = false;
  подредиСтъпките();
  // Страницата на семейството държи времето и невъзможните зони: смени ли
  // се човекът, трябва да ги преизчисли. Христина не прави „дете под 3",
  // и това трябва да се зачеркне веднага, а не при следващото натискане.
  // Триажът се преизчислява при смяна на нивото: въпросът за стария грим
  // важи за първичната, а за поддръжката се иска снимка. Пази се вече
  // даденият отговор, за да не я питаме пак при връщане назад.
  опресниТриажа();
  опресниПоканата();

  // КАЛЕНДАРЪТ ИДВА ПРИ НЕЯ, НЕ ТЯ ПРИ НЕГО.
  //
  // Антонио, 30.10.2026, по телефона: „натискаш ги и трябва да знаеш, че
  // трябва да смъкнеш надолу за календар." Списъкът с хората е висок, а
  // след него идва денят — на телефон той остава под ръба на екрана и
  // жената не се сеща, че трябва да скролва. Избра човек и спира.
  //
  // Списъкът НЕ се свива: Мила поиска точно обратното на 29.10 — избереш
  // ли човек, за да се върнеш на друг, трябваше пак да цъкаш свитото.
  // Затова той остава отворен, а екранът се примества до календара.
  //
  // Чака се един кадър: `нарисувайДни` току-що е сменило съдържанието и
  // височината още не е преизчислена, тоест превъртането би отишло на
  // старото място. `block:'start'` го слага най-отгоре, за да се вижда
  // целият месец, а не долният му ръб.
  if(триажГотов()) requestAnimationFrame(function(){
    // Календарът вече стои НАД списъка (виж mila-zapazi.liquid), затова
    // превъртането е нагоре, не надолу: показва се самият месец заедно с
    // реда над него, за да се вижда чий е.
    var ц = $('rez-red-den') || $('rez-dni');
    if(ц && ц.scrollIntoView) try{
      ц.scrollIntoView({block:'start', behavior:'smooth'});
    }catch(e){ ц.scrollIntoView(true); }
  });

  if(typeof window.MILA_SLED_SMYANA === 'function') window.MILA_SLED_SMYANA(ИЗБРАНО, избор.specialist);
}
var отвориХора = смениНиво;

// Триажът следва избраното ниво: въпросът за стария грим важи за
// първичната, а поддръжката иска снимка. Вика се и при чиповете, не само
// при смяна на човек — иначе поддръжката показваше въпроса за грима.
function опресниТриажа(){
  var новВид = видТриаж();
  if(новВид === ТРИАЖ.вид) return;
  ТРИАЖ = { вид: новВид, стар: ТРИАЖ.стар, снимка: ТРИАЖ.снимка, преглед: ТРИАЖ.преглед };
  рисувайТриаж();
}
// Чиповете викат това при всяка смяна. Нужно е, защото „над 20 кв. см"
// няма услуга зад себе си: нормалният път през MILA_OGRANICHI не се
// стига и блокът никога не се показваше. 12.10.2026.
window.MILA_OPRESNI_TRIAZH = опресниТриажа;

// ---------------------------------------------------------------- старт
function пусни(){
  // Въпросникът вече е питал „правила ли си траен грим". Носи отговора в
  // адреса като ?star=ne / ?star=da, за да не я питаме втори път същото
  // веднага след като е отговорила. Решено с Антонио на 08.10.2026.
  var отВъпросника = null;
  try{
    var п0 = new URLSearchParams(location.search).get('star');
    if(п0 === 'ne') отВъпросника = 'не';
    if(п0 === 'da') отВъпросника = 'да';
  }catch(e){}

  ТРИАЖ = { вид: видТриаж(), стар: отВъпросника, снимка:null };
  рисувайТриаж();
  ЗАРЕЖДА = true;
  var моето = ++ПОКОЛЕНИЕ;
  clearTimeout(window.__МИЛА_ПРЕДЕЛ);
  window.__МИЛА_ПРЕДЕЛ = setTimeout(function(){ ЗАРЕЖДА = false; }, 25000);
  ПОНИВА = {}; РЕДОВЕ = []; ЦЕНИ = {}; ПОКАПАРО = {}; РЪЧНО_ИЗБРАН = false;
  избор = { specialist:null, mesec:null, den:null, chas:null, staff_id:null };
  свито = { den:false, chas:false };
  сприТаймер();
  var п = $('rez-potvardi'); if(п) п.hidden = true;
  var ч = $('rez-chasove');
  if(ч) ч.innerHTML = '<div class="rez-chaka">Свалям свободните часове…</div>';
  var д = $('rez-dni'); if(д) д.innerHTML = '';
  подредиСтъпките();
  return всичкиНива().then(function(нива){
  if(моето !== ПОКОЛЕНИЕ) return;   // изпреварено: мълчим и не пипаме нищо
  // Дойде ли човекът от въпросника с избран град, другият салон не му
  // върши работа. Пресяваме преди всичко останало, за да не се напълни
  // календарът с часове, които после уж сме скрили.
  var искангр;
  try{ искангр = new URLSearchParams(location.search).get('grad'); }catch(e){}
  // Другият салон не изчезва, а се помни: ако там има по-скоро или
  // по-евтино, казваме го с един ред. Антонио, 08.10.2026: жена, избрала
  // София, не знаеше, че в Стара Загора има свободен час утре срещу 400 €
  // вместо 550 € през февруари. Не я местим насила, но ѝ даваме избора.
  ДРУГИЯТ = null;
  нива.forEach(function(н){
    (н.kapara || []).forEach(function(к){
      if(к.kaparo != null) ПОКАПАРО[н.ниво.usluga + '|' + к.staff_id] = Number(к.kaparo);
    });
    ПОНИВА[н.ниво.usluga] = искангр
      ? н.redove.filter(function(r){ return r.grad === искангр; })
      : н.redove;
    // Внимание: тук редовете са СУРОВИ часове от сървъра — те имат `den`,
    // а не `parvi`. `parvi` се появява чак в нарисувайХора, когато всеки
    // човек се свие до един ред. Първия път написах `r.parvi` и редът за
    // другия салон не излизаше изобщо.
    if(искангр) н.redove.forEach(function(r){
      if(!r.grad || r.grad === искангр || !r.den) return;
      if(!ДРУГИЯТ || r.den < ДРУГИЯТ.parvi ||
         (r.den === ДРУГИЯТ.parvi && Number(r.cena) < Number(ДРУГИЯТ.cena)))
        ДРУГИЯТ = {grad:r.grad, parvi:r.den, cena:r.cena, usluga:н.ниво.usluga, staff:r.staff};
    });
  });
  ЗАРЕЖДА = false;   // часовете вече са тук: оттук нататък отговорът е верен
  clearTimeout(window.__МИЛА_ПРЕДЕЛ);
  if(typeof window.MILA_SLED_ZAREZHDANE === 'function'){
    try{ window.MILA_SLED_ZAREZHDANE(); }catch(e){}
  }
  var общо = Object.keys(ПОНИВА).reduce(function(n, к){ return n + ПОНИВА[к].length; }, 0);

  if(!общо && искангр){
    var к = $('usl-hora');
    if(к) к.innerHTML = '<div class="usl-chaka">В ' + искангр +
      ' няма свободен час за тази процедура. Обади се на ' +
      телЛинк(искангр) + ' или ' +
      '<a href="?">виж и другия салон</a>.</div>';
    $('rez-chasove').innerHTML = '';
    var д = $('rez-dni'); if(д) д.innerHTML = '';
    return;
  }
  if(!общо){
    $('rez-chasove').innerHTML = '<div class="rez-chaka">Няма свободни часове напред. ' +
      'Обади се на ' + телЛинк() + ' и ще ти намерим.</div>';
    var г = $('usl-hora');
    if(г) г.innerHTML = '<div class="usl-chaka">Свободните часове се дават по телефона: ' +
      '' + телЛинк() + '.</div>';
    return;
  }
  нарисувайХора();
  опитайОткрито();
  опресниПоканата();
  отвориИсканото();
  нарисувайДни();
  нарисувайЧасове();
  подредиСтъпките();
  слезиПриЧасовете();
}).catch(function(e){
  if(моето !== ПОКОЛЕНИЕ) return;
  ЗАРЕЖДА = false;   // провалът е отговор: не оставяме „Свалям…" завинаги
  clearTimeout(window.__МИЛА_ПРЕДЕЛ);
  if(typeof window.MILA_SLED_ZAREZHDANE === 'function'){
    try{ window.MILA_SLED_ZAREZHDANE(); }catch(e){}
  }
  $('rez-chasove').innerHTML = '<div class="rez-chaka">Календарът не отговори. ' +
    'Обади се на ' + телЛинк() + '.<br><small>' + e.message + '</small></div>';
});
}

// Дойде ли човекът от въпросника, той вече е отговорил какво търси.
// Отваряме страницата там, където се избира ден: котвата #rez сработва
// преди часовете да са пристигнали и сяда на празно място.
function слезиПриЧасовете(){
  var от;
  try{ от = new URLSearchParams(location.search).get('ot'); }catch(e){}
  if(от !== 'vapros') return;
  // Къде точно да спре. Ако още има въпрос или снимка за качване, целта е
  // ТЯ: инак жената пада при календара, който е заключен, и не вижда защо.
  // А ако всичко е отговорено, целта е изборът на човек.
  //
  // Чака се един кадър след рисуването: иначе мерим височини отпреди
  // чиповете и триажа да са влезли, и страницата слиза твърде надолу —
  // чак при „как протича процедурата". Видяно от Антонио, 08.10.2026.
  var тр = document.querySelector('.rez-triazh');
  var цел = (тр && !тр.hidden && !триажГотов()) ? тр : ($('usl-hora') || $('rez-dni'));
  if(!цел) return;
  // Horizon скролва div.page-wrapper, не прозореца: scrollIntoView сам
  // намира правилния родител, затова минаваме през него.
  setTimeout(function(){
    цел.scrollIntoView({block:'start', behavior:'smooth'});
  }, 260);
}

// „Запази час": процедурата се избира тук, а не идва от продукта.
var избирач = document.getElementById('rez-usluga');
if(избирач){
  избирач.addEventListener('change', function(){
    var о = избирач.options[избирач.selectedIndex];
    if(!о || !о.value) return;
    сек.dataset.usluga = о.value;
    сек.dataset.pylna  = о.dataset.pylna;
    сек.dataset.kaparo = о.dataset.kaparo;
    сек.dataset.traene = о.dataset.traene;
    сек.dataset.ime    = о.dataset.ime;
    сек.dataset.niva   = о.dataset.niva || '[]';
    прочетиУслугата();
    пусни();
  });
}

// Падне ли нещо неочаквано, страницата пак трябва да казва какво да прави човекът.
try{ пусни(); }catch(e){
  $('rez-chasove').innerHTML = '<div class="rez-chaka">Календарът не отговори. ' +
    'Обади се на ' + телЛинк() + '.</div>';
  var г0 = $('usl-hora');
  if(г0) г0.innerHTML = '<div class="usl-chaka">Часовете за тази процедура се дават по телефона: ' +
    '' + телЛинк() + '.</div>';
}

})();
